<template>
  <div>
    <v-card color="grey lighten-5" flat>
      <rezervasyonekleridialog
        ref="rezervasyonekleridialog"
      ></rezervasyonekleridialog>
      <dosyaekleridialog ref="dosyaekleridialog"></dosyaekleridialog>

      <vizetipekledialog ref="vizetipekledialog"></vizetipekledialog>

      <v-form>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar
              style="height: 48px; align-items: baseline"
              class="baslik"
              size="120px"
              dark
              color="info"
            >
              <v-toolbar-title class="baslikfont">{{ baslik }}</v-toolbar-title>
              <v-spacer></v-spacer>
              
                <v-checkbox label="Tüm Şirketlerde Uygula" class="justify-end" v-model="Satici.tumSirketler" hide-details>
                </v-checkbox>
              <v-btn v-if="guncellebuton" @click="guncelle()" flat>
                <span class="hidden-sm-and-down"> Güncelle </span>
                <v-icon right dark>create</v-icon>
              </v-btn>
              <v-btn v-if="kaydetbuton" @click="Kaydet()" flat>
                <span class="hidden-sm-and-down">
                  {{ $t("save_button") }}
                </span>
                <v-icon right dark>save</v-icon>
              </v-btn>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list v-if="guncellebuton">
                  <v-list-tile @click="carisil()">
                    <v-list-tile-title>Satıcı Sil</v-list-tile-title>
                  </v-list-tile>
                </v-list>
                <v-list>
                  <a
                    v-if="this.Satici.SaticiTipi == 1"
                    id="backLink"
                    target="_self"
                    v-bind:href="'#/coper/otel/index/'"
                  >
                    <v-list-tile>
                      <v-list-tile-title>{{$t('Hotel-List')}}</v-list-tile-title>
                    </v-list-tile>
                  </a>
                  <a
                    v-if="this.Satici.SaticiTipi == 2"
                    id="backLink"
                    target="_self"
                    v-bind:href="'#/coper/transfer/index/'"
                  >
                    <v-list-tile>
                      <v-list-tile-title>Transfer Listesi</v-list-tile-title>
                    </v-list-tile>
                  </a>
                  <a
                    v-if="this.Satici.SaticiTipi == 3"
                    id="backLink"
                    target="_self"
                    v-bind:href="'#/coper/restaurant/index/'"
                  >
                    <v-list-tile>
                      <v-list-tile-title>Restaurant Listesi</v-list-tile-title>
                    </v-list-tile>
                  </a>
                  <a
                    v-if="this.Satici.SaticiTipi == 4"
                    id="backLink"
                    target="_self"
                    v-bind:href="'#/coper/acente/index/'"
                  >
                    <v-list-tile>
                      <v-list-tile-title>Acente Listesi</v-list-tile-title>
                    </v-list-tile>
                  </a>
                  <a
                    v-if="this.Satici.SaticiTipi == 5"
                    id="backLink"
                    target="_self"
                    v-bind:href="'#/coper/rentacar/index/'"
                  >
                    <v-list-tile>
                      <v-list-tile-title>Rent A Car Listesi</v-list-tile-title>
                    </v-list-tile>
                  </a>
                  <a
                    v-if="this.Satici.SaticiTipi == 6"
                    id="backLink"
                    target="_self"
                    v-bind:href="'#/coper/rehber/index/'"
                  >
                    <v-list-tile>
                      <v-list-tile-title>Rehber Listesi</v-list-tile-title>
                    </v-list-tile>
                  </a>
                  <a
                    v-if="this.Satici.SaticiTipi == 7"
                    id="backLink"
                    target="_self"
                    v-bind:href="'#/coper/muze/index/'"
                  >
                    <v-list-tile>
                      <v-list-tile-title>Müze Listesi</v-list-tile-title>
                    </v-list-tile>
                  </a>
                  <a
                    v-if="this.Satici.SaticiTipi == 8"
                    id="backLink"
                    target="_self"
                    v-bind:href="'#/coper/charter/index/'"
                  >
                    <v-list-tile>
                      <v-list-tile-title>Charter Listesi</v-list-tile-title>
                    </v-list-tile>
                  </a>
                  <a
                    v-if="this.Satici.SaticiTipi == 9"
                    id="backLink"
                    target="_self"
                    v-bind:href="'#/coper/gemi/index/'"
                  >
                    <v-list-tile>
                      <v-list-tile-title>Gemi Listesi</v-list-tile-title>
                    </v-list-tile>
                  </a>
                  <a
                    v-if="this.Satici.SaticiTipi == 10"
                    id="backLink"
                    target="_self"
                    v-bind:href="'#/coper/diger/index/'"
                  >
                    <v-list-tile>
                      <v-list-tile-title>Diğer Listesi</v-list-tile-title>
                    </v-list-tile>
                  </a>
                  <a
                    v-if="this.Satici.SaticiTipi == 11"
                    id="backLink"
                    target="_self"
                    v-bind:href="'#/coper/vize/index/'"
                  >
                    <v-list-tile>
                      <v-list-tile-title>Vize Listesi</v-list-tile-title>
                    </v-list-tile>
                  </a>
                  <a
                    v-if="this.Satici.SaticiTipi == 12"
                    id="backLink"
                    target="_self"
                    v-bind:href="'#/coper/turoperator/index/'"
                  >
                    <v-list-tile>
                      <v-list-tile-title
                        >Tur Operatör Listesi</v-list-tile-title
                      >
                    </v-list-tile>
                  </a>
                  <a
                    v-if="this.Satici.SaticiTipi == 14"
                    id="backLink"
                    target="_self"
                    v-bind:href="'#/coper/sigorta/index/'"
                  >
                    <v-list-tile>
                      <v-list-tile-title>Sigorta Listesi</v-list-tile-title>
                    </v-list-tile>
                  </a>
                  <a
                    v-if="this.Satici.SaticiTipi == 15"
                    id="backLink"
                    target="_self"
                    v-bind:href="'#/coper/feribot/index/'"
                  >
                    <v-list-tile>
                      <v-list-tile-title>Sigorta Listesi</v-list-tile-title>
                    </v-list-tile>
                  </a>
                  <a
                    v-if="this.Satici.SaticiTipi == 16"
                    id="backLink"
                    target="_self"
                    v-bind:href="'#/coper/golf/index/'"
                  >
                    <v-list-tile>
                      <v-list-tile-title>Golf Listesi</v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-tabs
            style="width: 100%; height: 100%"
            dark=""
            v-model="active"
            color="blue darken-3"
            slot="extension"
            slider-
          >
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#0">
              {{ $t("tab_general") }}
            </v-tab>
            <v-tab-item :id="'0'" style="width: 100%">
              <v-form ref="formsatici" v-model="valid" lazy-validation>
                <v-layout row="" wrap="">
                  <v-flex pa-1 xs12 sm4 md4>
                    <v-card class="white--text">
                      <v-card color="grey lighten-4" flat="">
                        <v-card-actions>
                          <v-layout justify-space-between column>
                            <v-text-field
                              hide-details=""
                              :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                              label="İsim"
                              v-model="Satici.Isim"
                            >
                            </v-text-field>

                            <v-text-field
                              hide-details=""
                              v-if="kaydetbuton"
                              :rules="[
                                (v) => !!v || $t('Mandatory-Areas'),
                                ,
                                () =>
                                  (!!Satici.Kod && Satici.Kod.length <= 50) ||
                                  '50 karakterden fazla olamaz',
                              ]"
                              label="Kod (max 50)"
                              v-model="Satici.Kod"
                            >
                            </v-text-field>
                            <cariaracomp
                              v-bind:etiket="$t('Current-Account')"
                              v-bind:value="Satici.Cari_Kod.kod"
                              :loading="loading"
                              v-bind:zorunlumu="true"
                              v-model="Satici.Cari_Kod.kod"
                              :Coper="true"
                              v-bind:statecariyedek="statecari"
                            ></cariaracomp>

                            <v-text-field
                              height="32px"
                              hide-details=""
                              :label="$t('Taxcenter_label')"
                              v-model="Satici.VDaire"
                            ></v-text-field>
                            <v-text-field
                              hide-details=""
                              :label="$t('Taxnumber_label')"
                              v-model="Satici.VNo"
                            ></v-text-field>
                            <v-text-field
                              hide-details=""
                              :label="$t('Authorized_label')"
                              v-model="Satici.Yetkili"
                            ></v-text-field>

                            <v-autocomplete
                              :items="ulkeTipi"
                              hide-details=""
                              :no-data-text="$t('No-Records-Found')"
                              v-model="Satici.Ulke"
                              item-text="Isim"
                              item-value="Isim"
                              clearable
                              :label="$t('Country_label')"
                              @change="getCity(Satici.Ulke)"
                            >
                            </v-autocomplete>

                            <v-autocomplete
                              @change="getDistinct(Satici.Sehir)"
                              :items="sehirTipi"
                              hide-details=""
                              v-model="Satici.Sehir"
                              :no-data-text="$t('No-Records-Found')"
                              item-text="Isim"
                              item-value="Isim"
                              clearable
                              :label="$t('City')"
                            >
                            </v-autocomplete>

                            <v-autocomplete
                              @change="getTown(Satici.Yer)"
                              :no-data-text="$t('No-Records-Found')"
                              :items="ilceTipi"
                              hide-details=""
                              v-model="Satici.Yer"
                              item-text="Isim"
                              item-value="Isim"
                              :label="$t('District')"
                            >
                            <template v-slot:append-outer>
                                <v-icon
                                  color="success"
                                  @click.native="addDistinctDialog = true"
                                >add_box</v-icon>
                            </template>
                            </v-autocomplete>

                            <v-autocomplete
                              :items="semtTipi"
                              hide-details=""
                              :no-data-text="$t('No-Records-Found')"
                              v-model="Satici.SaticiKonumu"
                              item-text="Isim"
                              item-value="Isim"
                              clearable
                              :label="$t('District-v2')"
                            >
                            <template v-slot:append-outer>
                                <v-icon
                                  color="success"
                                  @click.native="addNeighborhoodDialog = true"
                                >add_box</v-icon>
                            </template>
                            </v-autocomplete>

                            <v-textarea
                              v-model="Satici.Adres"
                              :label="$t('Address_label')"
                            ></v-textarea>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>

                  <v-flex pa-1 xs12 sm4 md4>
                    <v-card class="white--text">
                      <v-card color="grey lighten-4" flat="">
                        <v-card-actions>
                          <v-layout justify-space-between column>
                            <v-text-field
                              hide-details=""
                              :label="$t('Postcode_label')"
                              value=""
                              v-model="Satici.PK"
                            >
                            </v-text-field>
                            <v-text-field
                              hide-details=""
                              label="Web"
                              v-model="Satici.Web"
                            ></v-text-field>
                            <v-text-field
                              hide-details=""
                              :label="$t('Telephone')"
                              v-model="Satici.Tel1"
                            ></v-text-field>
                            <v-text-field
                              hide-details=""
                              :label="$t('Telephone') + '2'"
                              v-model="Satici.Tel2"
                            ></v-text-field>
                            <v-text-field
                              hide-details=""
                              label="Fax"
                              v-model="Satici.Fax"
                            ></v-text-field>
                            <v-text-field
                              hide-details=""
                              :label="$t('Telex-No')"
                              v-model="Satici.Teleks"
                            ></v-text-field>
                            <v-text-field
                              hide-details=""
                              :label="$t('Email_label')"
                              v-model="Satici.Email"
                            ></v-text-field>
                            <v-text-field
                              hide-details=""
                              label="GSM"
                              v-model="Satici.GSM"
                            ></v-text-field>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>

                  <v-flex pa-1 xs12 sm4 md4>
                    <v-card class="white--text">
                      <v-card color="grey lighten-4" flat="">
                        <v-card-actions>
                          <v-layout justify-space-between column wrap>
                            <v-select
                              :items="saticiTipi"
                              hide-details=""
                              v-model="Satici.Ic_Dis"
                              item-text="text"
                              item-value="value"
                              clearable
                              :label="$t('Seller-Type')"
                            ></v-select>
                            <v-text-field
                              hide-details=""
                              :label="$t('Group')"
                              v-model="Satici.Grup"
                            ></v-text-field>
                            <v-text-field
                              hide-details=""
                              :label="$t('Distance-to-Airport')"
                              v-model="Satici.HavaAlani"
                            >
                            </v-text-field>
                            <v-text-field
                              hide-details=""
                              :label="$t('Global-Code')"
                              v-model="Satici.GlobalKod"
                            ></v-text-field>
                            <v-text-field
                              hide-details=""
                              :label="$t('Chain-Code')"
                              v-model="Satici.ZincirKodu"
                            >
                            </v-text-field>
                            <v-layout>
                              <v-text-field
                                hide-details=""
                                :label="$t('Coordinate-Parallel-Der')"
                                v-model="Satici.krdDerece"
                              >
                              </v-text-field>
                              <v-text-field
                                hide-details=""
                                :label="$t('Min')"
                                v-model="Satici.krdDakika"
                              ></v-text-field>
                              <v-text-field
                                hide-details=""
                                :label="$t('Sec')"
                                v-model="Satici.krdSaniye"
                              ></v-text-field>
                            </v-layout>
                            <v-layout>
                              <v-text-field
                                hide-details=""
                                :label="$t('Coordinate-Meridian-Der')"
                                v-model="Satici.krdDereceM"
                              >
                              </v-text-field>
                              <v-text-field
                                hide-details=""
                                :label="$t('Min')"
                                v-model="Satici.krdDakikaM"
                              ></v-text-field>
                              <v-text-field
                                hide-details=""
                                :label="$t('Sec')"
                                v-model="Satici.krdSaniyeM"
                              ></v-text-field>
                            </v-layout>

                            <v-checkbox
                              v-model="Satici.PasifKayit"
                              :label="$t('Make-this-record-passive')"
                            ></v-checkbox>
                            <v-layout justify-end row wrap>
                              <v-flex pa-1 xs12 sm6 md4> </v-flex>
                              <v-flex pa-1 xs12 sm6 md4>
                                <v-btn
                                  block
                                  color="info"
                                  v-if="
                                    this.Satici.SaticiTipi == 1 ||
                                    this.Satici.SaticiTipi == 8 ||
                                    this.Satici.SaticiTipi == 9 ||
                                    this.Satici.SaticiTipi == 11
                                  "
                                  @click="rezervasyonekleri()"
                                  > {{ $t('Reservation-Attachments') }} </v-btn
                                >
                              </v-flex>
                              <v-flex pa-1 xs12 sm6 md4>
                                <v-btn
                                  block
                                  color="info"
                                  @click="dokumanEkler()"
                                  > {{ $t('Additional-Documents') }} 
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-tab-item>
            <v-tab href="#1" v-if="this.Satici.SaticiTipi != 14" ripple>
              Özellikler
            </v-tab>
            <v-tab-item :id="'1'" style="width: 100%; height: 100%">
              <v-layout v-if="this.Satici.SaticiTipi == 1" row="" wrap="">
                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-autocomplete
                                    hide-details
                                    item-text="Isim"
                                    item-value="Id"
                                    v-model="Satici.stOtel.Ucretsizler"
                                    :items="ucretsizOzelliklertumList"
                                    chips
                                    :label="$t('Free-Features')"
                                    multiple
                                  >
                                  </v-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-autocomplete
                                    hide-details
                                    item-text="Isim"
                                    item-value="Id"
                                    v-model="Satici.stOtel.Ucretliler"
                                    :items="ucretsizOzelliklertumList"
                                    chips
                                    :label="$t('Paid-Features')"
                                    multiple
                                  >
                                  </v-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-autocomplete
                                    hide-details
                                    item-text="Isim"
                                    item-value="Id"
                                    v-model="Satici.stOtel.Kategori"
                                    :items="kategoriitems"
                                    :label="$t('Category')"
                                  >
                                  </v-autocomplete>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-radio-group
                            hide-details=""
                            label="Otel Tipi :"
                            v-model="Satici.stOtel.OtelTip"
                            row
                          >
                            <v-radio :label="$t('City-Hotel')" :value="0"></v-radio>
                            <v-radio :label="$t('Holiday-Resorts')" :value="1"></v-radio>
                          </v-radio-group>
                          <tarihim
                            :etiket="$t('Employment-Period-Start')"
                            :detaygizle="true"
                            v-model="Satici.stOtel.Donem1"
                            v-bind:value="Satici.stOtel.Donem1"
                            v-bind:defaultvalue="'no'"
                          ></tarihim>
                          <tarihim
                            :etiket="$t('Employment-Period-End')"
                            :detaygizle="true"
                            v-model="Satici.stOtel.Donem2"
                            v-bind:value="Satici.stOtel.Donem2"
                            v-bind:defaultvalue="'no'"
                          ></tarihim>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-text-field
                                    hide-details=""
                                    :label="$t('Sales-Manager')"
                                    v-model="Satici.stOtel.SatisMuduru"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-text-field
                                    hide-details=""
                                    :label="$t('General-Manager')"
                                    v-model="Satici.stOtel.GenelMudur"
                                  >
                                  </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-text-field
                                    hide-details=""
                                    :label="$t('Accounting-Manager')"
                                    v-model="Satici.stOtel.MuhasebeMuduru"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-text-field
                                    hide-details=""
                                    :label="$t('Other-Official')"
                                    v-model="Satici.stOtel.DigerYetkili"
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout v-if="this.Satici.SaticiTipi == 2" row="" wrap="">
                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <tarihim
                            :etiket="$t('Employment-Period-Start')"
                            :detaygizle="true"
                            v-model="Satici.stArac.Donem1"
                            v-bind:value="Satici.stArac.Donem1"
                            v-bind:defaultvalue="'no'"
                          ></tarihim>
                          <tarihim
                            :etiket="$t('Employment-Period-End')"
                            :detaygizle="true"
                            v-model="Satici.stArac.Donem2"
                            v-bind:value="Satici.stArac.Donem2"
                            v-bind:defaultvalue="'no'"
                          ></tarihim>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm6 md8>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-card flat>
                                    <v-layout row wrap>
                                      <v-flex xs12 pa-2 sm12 md12>
                                        <v-icon medium="" color="grey"
                                          >directions_car</v-icon
                                        >
                                        &nbsp;
                                        <span
                                          class="font-weight-regular grey--text title"
                                          > {{ $t('Vehicle-Type-Selection') }} </span
                                        >
                                        <v-divider></v-divider>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md3>
                                        <v-autocomplete
                                          hide-details
                                          item-text="`${data.item.Ana}, ${data.item.Alt}`"
                                          item-value="`${data.item.Ana}, ${data.item.Alt}`"
                                          v-model="AracTipleri"
                                          :items="aracOzelliklertumList"
                                          label="Araç Tipleri"
                                        >
                                          <template
                                            slot="selection"
                                            slot-scope="data"
                                          >
                                            {{ data.item.Ana }}-
                                            {{ data.item.Alt }}
                                          </template>
                                          <template
                                            slot="item"
                                            slot-scope="data"
                                          >
                                            <v-list-tile-content>
                                              <v-list-tile-title
                                                v-html="
                                                  `${data.item.Ana} - ${data.item.Alt}`
                                                "
                                              >
                                              </v-list-tile-title>
                                            </v-list-tile-content>
                                          </template>
                                        </v-autocomplete>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md3>
                                        <v-text-field
                                          hide-details=""
                                          v-model="Aractipi.AnaTip"
                                          :label="$t('Main-Type')"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md3>
                                        <v-text-field
                                          hide-details=""
                                          v-model="Aractipi.AltTip"
                                          :label="$t('Sub-Type')"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md3>
                                        <v-text-field
                                          hide-details=""
                                          v-model="Aractipi.AracAdi"
                                          :label="$t('Vehicle-Name')"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md3>
                                        <v-text-field
                                          hide-details=""
                                          mask="########"
                                          v-model="Aractipi.YazEnAz"
                                          :label="$t('Summer-Least')"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 sm12 pa-1 md3>
                                        <v-text-field
                                          hide-details=""
                                          mask="########"
                                          v-model="Aractipi.YazEnCok"
                                          :label="$t('Summer-Most')"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md3>
                                        <v-text-field
                                          hide-details=""
                                          mask="########"
                                          v-model="Aractipi.KisEnAz"
                                          :label="$t('Winter-Least')"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md3>
                                        <v-text-field
                                          hide-details=""
                                          mask="########"
                                          v-model="Aractipi.KisEnCok"
                                          :label="$t('Winter-Most')"
                                        >
                                        </v-text-field>
                                      </v-flex>
                                      <v-flex xs12 sm12 md12 pa-2>
                                        <v-layout justify-end row>
                                          <v-btn
                                            @click="aracEkle()"
                                            flat
                                            color="info"
                                          >
                                            <v-icon>add</v-icon>{{$t('Add-to-List')}}
                                          </v-btn>
                                        </v-layout>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>

                                <v-flex xs12 pt-3 sm12 md12>
                                  <v-card flat>
                                    <v-layout row wrap>
                                      <v-flex xs12 pa-2 sm12 md12>
                                        <v-icon medium="" color="grey"
                                          >view_headline</v-icon
                                        >
                                        &nbsp;
                                        <span
                                          class="font-weight-regular grey--text title"
                                          > {{ $t('Added-Vehicles') }} </span
                                        >
                                        <v-divider></v-divider>
                                      </v-flex>

                                      <v-flex xs12 sm12 md12>
                                        <v-data-table
                                          :headers="headersarac"
                                          dense
                                          :rows-per-page-items="[50, 100]"
                                          :items="itemsarac"
                                        >
                                          <template
                                            slot="items"
                                            slot-scope="props"
                                          >
                                            <tr item>
                                              <td class="text-xs-left">
                                                {{ props.item.AnaTip }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.AltTip }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.AracAdi }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.YazEnAz }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.YazEnCok }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.KisEnAz }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.KisEnCok }}
                                              </td>

                                              <td
                                                class="justify-center layout px-0"
                                              >
                                                <!-- <v-btn icon class="mx-0" @click="tahsilatgetir(props.item)">
                                                  <v-icon color="teal">edit</v-icon>
                                                </v-btn> -->
                                                <v-btn
                                                  icon
                                                  class="mx-0"
                                                  @click="aracSil(props.item)"
                                                >
                                                  <v-icon color="pink"
                                                    >delete</v-icon
                                                  >
                                                </v-btn>
                                              </td>
                                            </tr>
                                          </template>
                                        </v-data-table>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout v-if="this.Satici.SaticiTipi == 3" row="" wrap="">
                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex pa-1 xs12 sm12 md12>
                            <tarihim
                              :etiket="$t('Unemployment-Period-Start')"
                              :detaygizle="true"
                              v-model="Satici.stRestaurant.Donem1"
                              v-bind:value="Satici.stRestaurant.Donem1"
                              v-bind:defaultvalue="'no'"
                            ></tarihim>
                          </v-flex>
                          <v-flex pa-1 xs12 sm12 md12>
                            <tarihim
                              :etiket="$t('Unemployment-Period-End')"
                              :detaygizle="true"
                              v-model="Satici.stRestaurant.Donem2"
                              v-bind:value="Satici.stRestaurant.Donem2"
                              v-bind:defaultvalue="'no'"
                            ></tarihim>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 pa-1 sm12 md4>
                            <v-text-field
                              hide-details=""
                              mask="########"
                              v-model="Satici.stRestaurant.KisiYaz"
                              :label="$t('Summer-Person-Number')"
                            >
                            </v-text-field>
                          </v-flex>

                          <v-flex xs12 sm12 pa-1 md4>
                            <v-text-field
                              hide-details=""
                              mask="########"
                              v-model="Satici.stRestaurant.KisiKis"
                              :label="$t('Winter-Person-Number')"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 pa-1 md4>
                            <v-text-field
                              hide-details=""
                              mask="########"
                              v-model="Satici.stRestaurant.MinKisi"
                              :label="$t('Least-Person-Number')"
                            >
                            </v-text-field>
                          </v-flex>

                          <v-flex xs12 sm12 pa-1 md12>
                            <v-text-field
                              hide-details=""
                              v-model="Satici.stRestaurant.Sinif"
                              :label="$t('Class-v2')"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 pa-1 md12>
                            <v-text-field
                              hide-details=""
                              v-model="Satici.stRestaurant.Sorumlu1"
                              :label="$t('Responsible') + '1'"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 pa-1 md12>
                            <v-text-field
                              hide-details=""
                              v-model="Satici.stRestaurant.Sorumlu2"
                              :label="$t('Responsible') + '2'"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout v-if="this.Satici.SaticiTipi == 4" row="" wrap="">
                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 pa-1 sm12 md12>
                            <v-text-field
                              hide-details=""
                              v-model="Satici.stAcente.AcenteTipi"
                              :label="$t('Agency-Type')"
                            >
                            </v-text-field>
                          </v-flex>

                          <v-flex xs12 sm12 pa-1 md12>
                            <v-autocomplete
                              hide-details=""
                              clearable
                              append-icon="search"
                              :label="$t('Main-Agency')"
                              v-model="secilenacente"
                              :loading="loadingacente"
                              :items="stateacente"
                              item-text="Aciklama"
                              item-value="Kod"
                              :search-input.sync="searchacente"
                              cache-items=""
                            >
                              <template slot="item" slot-scope="data">
                                {{ data.item.Kod }}-{{ data.item.Aciklama }}
                              </template>
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm12 pa-1 md12>
                            <v-text-field
                              hide-details=""
                              v-model="Satici.stAcente.Sorumlu1"
                              :label="$t('Responsible') + '1'"
                            >
                            </v-text-field>
                          </v-flex>

                          <v-flex xs12 sm12 pa-1 md12>
                            <v-text-field
                              hide-details=""
                              v-model="Satici.stAcente.Sorumlu2"
                              :label="$t('Responsible') + '2'"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex pa-1 xs12 sm12 md12>
                            <v-radio-group
                              hide-details=""
                              v-model="Satici.stAcente.AcenteTip"
                              row
                            >
                              <v-radio
                                :label="$t('Central-Agency')"
                                :value="0"
                              ></v-radio>
                              <v-radio
                                :label="$t('Secondary-Sub-Agency')"
                                :value="1"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                          <v-flex pa-1 xs12 sm12 md12>
                            <tarihim
                              :etiket="$t('Unemployment-Period-Start')"
                              :detaygizle="true"
                              v-model="Satici.stAcente.Donem1"
                              v-bind:value="Satici.stAcente.Donem1"
                              v-bind:defaultvalue="'no'"
                            ></tarihim>
                          </v-flex>
                          <v-flex pa-1 xs12 sm12 md12>
                            <tarihim
                              :etiket="$t('Unemployment-Period-End')"
                              :detaygizle="true"
                              v-model="Satici.stAcente.Donem2"
                              v-bind:value="Satici.stAcente.Donem2"
                              v-bind:defaultvalue="'no'"
                            ></tarihim>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 pa-1 md12>
                            <v-checkbox
                              :label="$t('Corporate-Client')"
                              v-model="Satici.stAcente.Kurumsal"
                              hide-details=""
                            >
                            </v-checkbox>
                          </v-flex>
                          <v-flex xs12 sm12 pa-1 md12>
                            <v-text-field
                              hide-details=""
                              v-if="Satici.stAcente.Kurumsal == true"
                              v-model="Satici.stAcente.Parola"
                              :label="$t('Password-v2')"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout v-if="this.Satici.SaticiTipi == 5" row="" wrap="">
                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <tarihim
                            :etiket="$t('Employment-Period-Start')"
                            :detaygizle="true"
                            v-model="Satici.stRentACar.Donem1"
                            v-bind:value="Satici.stRentACar.Donem1"
                            v-bind:defaultvalue="'no'"
                          ></tarihim>
                          <tarihim
                            :etiket="$t('Employment-Period-End')"
                            :detaygizle="true"
                            v-model="Satici.stRentACar.Donem2"
                            v-bind:value="Satici.stRentACar.Donem2"
                            v-bind:defaultvalue="'no'"
                          ></tarihim>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm6 md8>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-form
                            ref="formrentacar"
                            v-model="validrentacar"
                            lazy-validation
                          >
                            <v-layout row wrap>
                              <v-flex pa-1 xs12 sm12 md12>
                                <v-layout row wrap>
                                  <v-flex xs12 sm12 md12>
                                    <v-card flat>
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-2 sm12 md12>
                                          <v-icon medium="" color="grey"
                                            >directions_car</v-icon
                                          >
                                          &nbsp;
                                          <span
                                            class="font-weight-regular grey--text title"
                                            > {{ $t('Vehicle-Presentation') }} </span
                                          >
                                          <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex
                                          v-if="sinifekleview"
                                          xs12
                                          pa-1
                                          sm12
                                          md3
                                        >
                                          <v-text-field
                                            v-model="yenisinif"
                                            hide-details=""
                                            :label="$t('New-Vehicle-Category')"
                                          >
                                          </v-text-field>
                                        </v-flex>

                                        <v-flex
                                          v-if="sinifekleview"
                                          xs12
                                          pa-1
                                          sm12
                                          md6
                                        >
                                          <v-layout
                                            justify-start
                                            align-end
                                            fill-height
                                          >
                                            <v-btn
                                              v-if="sinifekleview"
                                              @click="sinifEkle()"
                                              flat
                                              color="info"
                                            >
                                              <v-icon>add</v-icon>{{ $t('Add') }}
                                            </v-btn>
                                            <v-btn
                                              v-if="sinifekleview"
                                              @click.native="
                                                sinifekleview = false
                                              "
                                              flat
                                              color="info"
                                            >
                                              <v-icon>cancel</v-icon
                                              >{{ $t("cancel_button") }}
                                            </v-btn>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex
                                          v-if="sinifekleview"
                                          xs12
                                          pa-2
                                          sm12
                                          md12
                                        >
                                          <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 pa-1 sm12 md3>
                                          <v-autocomplete
                                            :rules="[
                                              (v) =>
                                                !!v || $t('Please-select-a-date'),
                                            ]"
                                            hide-details
                                            v-model="RentACar.Kategori"
                                            :items="itemsaracsinifi"
                                            item-text="Kod"
                                            item-value="Kod"
                                            :label="$t('Vehicle-Category')"
                                          >
                                          </v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 pa-1 sm12 md9>
                                          <v-layout
                                            justify-start
                                            align-end
                                            fill-height
                                          >
                                            <v-btn
                                              v-if="!sinifekleview"
                                              @click.native="
                                                sinifekleview = true
                                              "
                                              flat
                                              color="info"
                                            >
                                              <v-icon>add</v-icon>
                                              Yeni Kategori Ekle
                                            </v-btn>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 pa-1 sm6 md4>
                                          <v-layout row wrap>
                                            <v-flex xs12 pa-1 sm12 md12>
                                              <v-text-field
                                                hide-details=""
                                                :rules="[
                                                  (v) =>
                                                    !!v ||
                                                    $t('Please-select-a-date'),
                                                ]"
                                                v-model="RentACar.Kod"
                                                label="Kod"
                                              >
                                              </v-text-field>
                                            </v-flex>

                                            <v-flex xs12 pa-1 sm12 md12>
                                              <v-autocomplete
                                                hide-details
                                                item-text="Isim"
                                                item-value="Id"
                                                v-model="RentACar.Marka"
                                                :rules="[
                                                  (v) =>
                                                    !!v ||
                                                    $t('Please-select-a-date'),
                                                ]"
                                                :items="itemsaracmarka"
                                                :label="$t('Brand')"
                                              >
                                              </v-autocomplete>
                                            </v-flex>

                                            <v-flex xs12 pa-1 sm12 md12>
                                              <v-autocomplete
                                                hide-details
                                                v-model="RentACar.Model"
                                                item-text="Isim"
                                                item-value="Id"
                                                :items="itemsaracmodel"
                                                :label="$t('Model')"
                                              >
                                              </v-autocomplete>
                                            </v-flex>
                                            <v-flex xs12 pa-1 sm12 md12>
                                              <v-text-field
                                                hide-details=""
                                                v-model="RentACar.AracAd"
                                                :label="$t('Vehicle-Name')"
                                              >
                                              </v-text-field>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 pa-1 sm4 md4>
                                          <v-layout row wrap>
                                            <v-flex xs12 sm12 pa-1 md12>
                                              <v-text-field
                                                hide-details=""
                                                mask="########"
                                                v-model="RentACar.SaatOpsiyonu"
                                                :label="$t('Time-Option')"
                                              >
                                              </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 pa-1 sm12 md12>
                                              <v-text-field
                                                hide-details=""
                                                mask="########"
                                                v-model="RentACar.Adet"
                                                :label="$t('Number')"
                                              >
                                              </v-text-field>
                                            </v-flex>

                                            <v-flex xs12 pa-1 sm12 md12>
                                              <v-text-field
                                                hide-details=""
                                                :rules="[
                                                  (v) =>
                                                    !!v ||
                                                    $t('Please-select-a-date'),
                                                ]"
                                                v-model="RentACar.Plaka"
                                                :label="$t('License-Plate')"
                                              >
                                              </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 pa-1 sm12 md12>
                                              <v-autocomplete
                                                hide-details
                                                v-model="RentACar.YakitTipi"
                                                :items="itemsyakittipi"
                                                :label="$t('Fuel-Type')"
                                              >
                                              </v-autocomplete>
                                            </v-flex>

                                            <!-- <v-flex xs12 pa-1 sm12 md12>
                                              <v-text-field hide-details="" mask="####" label="Model Yılı">
                                              </v-text-field>
                                            </v-flex> -->
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 pa-2>
                                          <v-layout justify-end row>
                                            <v-btn
                                              @click="rentacararacEkle()"
                                              flat
                                              color="info"
                                            >
                                              <v-icon>add</v-icon> {{$t('Add-to-List')}}
                                            </v-btn>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-card>
                                  </v-flex>

                                  <v-flex xs12 pt-3 sm12 md12>
                                    <v-card flat>
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-2 sm12 md12>
                                          <v-icon medium="" color="grey"
                                            >view_headline</v-icon
                                          >
                                          &nbsp;
                                          <span
                                            class="font-weight-regular grey--text title"
                                            > {{ $t('Added-Vehicles') }} </span
                                          >
                                          <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                          <v-data-table
                                            :headers="headersrentacarliste"
                                            dense
                                            :rows-per-page-items="[50, 100]"
                                            :items="itemsrentacarliste"
                                          >
                                            <template
                                              slot="items"
                                              slot-scope="props"
                                            >
                                              <tr item>
                                                <td class="text-xs-left">
                                                  {{ props.item.Kategori }}
                                                </td>
                                                <td class="text-xs-left">
                                                  {{ props.item.Kod }}
                                                </td>
                                                <td class="text-xs-left">
                                                  {{ props.item.Marka }}
                                                </td>
                                                <td class="text-xs-left">
                                                  {{ props.item.Model }}
                                                </td>
                                                <td class="text-xs-left">
                                                  {{ props.item.AracAd }}
                                                </td>
                                                <td class="text-xs-left">
                                                  {{ props.item.Plaka }}
                                                </td>
                                                <td class="text-xs-left">
                                                  {{ props.item.Adet }}
                                                </td>

                                                <td
                                                  class="justify-center layout px-0"
                                                >
                                                  <!-- <v-btn icon class="mx-0" @click="tahsilatgetir(props.item)">
                                                  <v-icon color="teal">edit</v-icon>
                                                </v-btn> -->
                                                  <v-btn
                                                    icon
                                                    class="mx-0"
                                                    @click="
                                                      rentacarSil(props.item)
                                                    "
                                                  >
                                                    <v-icon color="pink"
                                                      >delete</v-icon
                                                    >
                                                  </v-btn>
                                                </td>
                                              </tr>
                                            </template>
                                          </v-data-table>
                                        </v-flex>
                                      </v-layout>
                                    </v-card>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-form>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout v-if="this.Satici.SaticiTipi == 6" row="" wrap="">
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs12 pa-1 sm12 md3>
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <tarihim
                                            :etiket="$t('Employment-Period-Start')"
                                            :detaygizle="true"
                                            v-model="Satici.stRehber.Donem1"
                                            v-bind:value="
                                              Satici.stRehber.Donem1
                                            "
                                            v-bind:defaultvalue="'no'"
                                          ></tarihim>
                                        </v-flex>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <tarihim
                                            :etiket="$t('Employment-Period-End')"
                                            :detaygizle="true"
                                            v-model="Satici.stRehber.Donem2"
                                            v-bind:value="
                                              Satici.stRehber.Donem2
                                            "
                                            v-bind:defaultvalue="'no'"
                                          ></tarihim>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 pa-1 sm12 md3>
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <v-radio-group
                                            hide-details=""
                                            :label="$t('Sex')"
                                            v-model="Satici.stRehber.Cinsiyet"
                                            row
                                          >
                                            <v-radio
                                              :label="$t('Male')"
                                              :value="0"
                                            ></v-radio>
                                            <v-radio
                                              :label="$t('Female')"
                                              :value="1"
                                            ></v-radio>
                                          </v-radio-group>
                                        </v-flex>

                                        <v-flex xs12 pa-1 sm12 md12>
                                          <v-text-field
                                            v-model="Satici.stRehber.Sinif"
                                            hide-details=""
                                            :label="$t('Class-v2')"
                                          >
                                          </v-text-field>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 pa-1 sm12 md3>
                                      <v-autocomplete
                                        multiple
                                        hide-details
                                        chips
                                        item-text="Dil"
                                        v-model="rehberbildigiDiller"
                                        :items="itemsdiller"
                                        :label="$t('Languages')"
                                      >
                                        <template
                                          slot="selection"
                                          slot-scope="{ item, index }"
                                        >
                                          <div v-if="index === 0">
                                            <span>{{ item.Dil }}</span>
                                          </div>
                                          <span
                                            v-if="index === 1"
                                            class="grey--text caption"
                                            >(+{{
                                              rehberbildigiDiller.length - 1
                                            }}
                                             {{$t('Other')}} )</span
                                          >
                                        </template>
                                      </v-autocomplete>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout v-if="this.Satici.SaticiTipi == 7" row="" wrap="">
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs12 pa-1 sm12 md3>
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <tarihim
                                            :etiket="$t('Employment-Period-Start')"
                                            :detaygizle="true"
                                            v-model="Satici.stMuze.Donem1"
                                            v-bind:value="Satici.stMuze.Donem1"
                                            v-bind:defaultvalue="'no'"
                                          ></tarihim>
                                        </v-flex>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <tarihim
                                            :etiket="$t('Employment-Period-End')"
                                            :detaygizle="true"
                                            v-model="Satici.stMuze.Donem2"
                                            v-bind:value="Satici.stMuze.Donem2"
                                            v-bind:defaultvalue="'no'"
                                          ></tarihim>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 pa-1 sm12 md3>
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <v-menu
                                            ref="menuacilis"
                                            v-model="menu2"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="
                                              Satici.stMuze.AcikSaat1
                                            "
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            max-width="290px"
                                            min-width="290px"
                                          >
                                            <template v-slot:activator="{ on }">
                                              <v-text-field
                                                hide-details
                                                v-model="
                                                  Satici.stMuze.AcikSaat1
                                                "
                                                :label="$t('Opening-Hours')"
                                                prepend-icon="access_time"
                                                v-on="on"
                                              ></v-text-field>
                                            </template>
                                            <v-time-picker
                                              v-if="menu2"
                                              format="24hr"
                                              v-model="Satici.stMuze.AcikSaat1"
                                              full-width
                                              @click:minute="
                                                $refs.menuacilis.save(
                                                  Satici.stMuze.AcikSaat1
                                                )
                                              "
                                            >
                                            </v-time-picker>
                                          </v-menu>
                                        </v-flex>

                                        <v-flex xs12 pa-1 sm12 md12>
                                          <v-menu
                                            ref="menukapanis"
                                            v-model="menu3"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="
                                              Satici.stMuze.AcikSaat2
                                            "
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            max-width="290px"
                                            min-width="290px"
                                          >
                                            <template v-slot:activator="{ on }">
                                              <v-text-field
                                                hide-details
                                                v-model="
                                                  Satici.stMuze.AcikSaat2
                                                "
                                                label="Kapanış Saat"
                                                prepend-icon="access_time"
                                                v-on="on"
                                              >
                                              </v-text-field>
                                            </template>
                                            <v-time-picker
                                              v-if="menu3"
                                              format="24hr"
                                              v-model="Satici.stMuze.AcikSaat2"
                                              full-width
                                              @click:minute="
                                                $refs.menukapanis.save(
                                                  Satici.stMuze.AcikSaat2
                                                )
                                              "
                                            >
                                            </v-time-picker>
                                          </v-menu>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 pa-1 sm12 md3>
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-2 sm12 md12>
                                          <v-icon medium="" color="grey"
                                            >event_available</v-icon
                                          >
                                          &nbsp;
                                          <span
                                            class="font-weight-regular grey--text title"
                                            > {{ $t('Weekly-Working-Days') }} </span
                                          >
                                          <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 pa-1 sm12 md12>
                                          <v-checkbox
                                            hide-details
                                            v-model="
                                              Satici.stMuze.AcikGunler.Pazartesi
                                            "
                                            :label="$t('Monday')"
                                          >
                                          </v-checkbox>

                                          <v-checkbox
                                            hide-details
                                            v-model="
                                              Satici.stMuze.AcikGunler.Sali
                                            "
                                            :label="$t('Tuesday')"
                                          >
                                          </v-checkbox>

                                          <v-checkbox
                                            hide-details
                                            v-model="
                                              Satici.stMuze.AcikGunler.Carsamba
                                            "
                                            :label="$t('Wednesday')"
                                          >
                                          </v-checkbox>

                                          <v-checkbox
                                            hide-details
                                            v-model="
                                              Satici.stMuze.AcikGunler.Persembe
                                            "
                                            :label="$t('Thursday')"
                                          >
                                          </v-checkbox>

                                          <v-checkbox
                                            hide-details
                                            v-model="
                                              Satici.stMuze.AcikGunler.Cuma
                                            "
                                            :label="$t('Friday')"
                                          >
                                          </v-checkbox>

                                          <v-checkbox
                                            hide-details
                                            v-model="
                                              Satici.stMuze.AcikGunler.Cumartesi
                                            "
                                            :label="$t('Saturday')"
                                          >
                                          </v-checkbox>

                                          <v-checkbox
                                            hide-details
                                            v-model="
                                              Satici.stMuze.AcikGunler.Pazar
                                            "
                                            :label="$t('Sunday')"
                                          >
                                          </v-checkbox>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout v-if="this.Satici.SaticiTipi == 8" row="" wrap="">
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs12 pa-1 sm12 md3>
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <tarihim
                                            :etiket="$t('Employment-Period-Start')"
                                            :detaygizle="true"
                                            v-model="Satici.stCharter.Donem1"
                                            v-bind:value="
                                              Satici.stCharter.Donem1
                                            "
                                            v-bind:defaultvalue="'no'"
                                          >
                                          </tarihim>
                                        </v-flex>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <tarihim
                                            :etiket="$t('Employment-Period-End')"
                                            :detaygizle="true"
                                            v-model="Satici.stCharter.Donem2"
                                            v-bind:value="
                                              Satici.stCharter.Donem2
                                            "
                                            v-bind:defaultvalue="'no'"
                                          >
                                          </tarihim>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 pa-1 sm12 md3>
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <v-autocomplete
                                            :items="itemsformno"
                                            item-text="FormNo"
                                            item-value="FormNo"
                                            hide-details=""
                                            v-model="Satici.stCharter.FormNo"
                                            :label="$t('Form-No')"
                                            clearable
                                          >
                                          </v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <v-autocomplete
                                            :items="itemsformno"
                                            item-text="Kodu"
                                            item-value="Kodu"
                                            hide-details=""
                                            v-model="Satici.stCharter.HY_Kodu"
                                            :label="$t('Airline-Code')"
                                            clearable
                                          ></v-autocomplete>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 pa-1 sm12 md3>
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <v-text-field
                                            hide-details=""
                                            v-model="Satici.stCharter.OpSure"
                                            mask="#######"
                                            label="Opsiyon Süresi"
                                          >
                                          </v-text-field>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout v-if="this.Satici.SaticiTipi == 9" row="" wrap="">
                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-autocomplete
                                    hide-details
                                    item-text="Isim"
                                    item-value="Id"
                                    v-model="Satici.stGemi.Ucretsizler"
                                    :items="ucretsizOzelliklertumList"
                                    chips
                                    :label="$t('Free-Features')"
                                    multiple
                                  >
                                  </v-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-autocomplete
                                    hide-details
                                    item-text="Isim"
                                    item-value="Id"
                                    v-model="Satici.stGemi.Ucretliler"
                                    :items="ucretsizOzelliklertumList"
                                    chips
                                    :label="$t('Paid-Features')"
                                    multiple
                                  >
                                  </v-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-autocomplete
                                    hide-details
                                    item-text="Isim"
                                    item-value="Id"
                                    v-model="Satici.stGemi.Kategori"
                                    :items="kategoriitems"
                                    :label="$t('Category')"
                                  >
                                  </v-autocomplete>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <tarihim
                            :etiket="$t('Employment-Period-Start')"
                            :detaygizle="true"
                            v-model="Satici.stGemi.Donem1"
                            v-bind:value="Satici.stGemi.Donem1"
                            v-bind:defaultvalue="'no'"
                          ></tarihim>
                          <tarihim
                            :etiket="$t('Employment-Period-End')"
                            :detaygizle="true"
                            v-model="Satici.stGemi.Donem2"
                            v-bind:value="Satici.stGemi.Donem2"
                            v-bind:defaultvalue="'no'"
                          ></tarihim>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-text-field
                                    hide-details=""
                                    :label="$t('Sales-Manager')"
                                    v-model="Satici.stGemi.SatisMuduru"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-text-field
                                    hide-details=""
                                    :label="$t('General-Manager')"
                                    v-model="Satici.stGemi.GenelMudur"
                                  >
                                  </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-text-field
                                    hide-details=""
                                    :label="$t('Accounting-Manager')"
                                    v-model="Satici.stGemi.MuhasebeMuduru"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-text-field
                                    hide-details=""
                                    :label="$t('Other-Official')"
                                    v-model="Satici.stGemi.DigerYetkili"
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout v-if="this.Satici.SaticiTipi == 10" row="" wrap="">
                <v-flex pa-1 xs12 sm12 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <tarihim
                            :etiket="$t('Employment-Period-Start')"
                            :detaygizle="true"
                            v-model="Satici.stDiger.Donem1"
                            v-bind:value="Satici.stDiger.Donem1"
                            v-bind:defaultvalue="'no'"
                          ></tarihim>
                          <tarihim
                            :etiket="$t('Employment-Period-End')"
                            :detaygizle="true"
                            v-model="Satici.stDiger.Donem2"
                            v-bind:value="Satici.stDiger.Donem2"
                            v-bind:defaultvalue="'no'"
                          ></tarihim>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout v-if="this.Satici.SaticiTipi == 11" row="" wrap="">
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs12 pa-1 sm12 md12>
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-1 sm12 md2>
                                          <v-menu
                                            ref="menuacilis"
                                            v-model="menu2"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="
                                              Satici.stKonsolosluk.Saat1
                                            "
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            max-width="290px"
                                            min-width="290px"
                                          >
                                            <template v-slot:activator="{ on }">
                                              <v-text-field
                                                hide-details
                                                v-model="
                                                  Satici.stKonsolosluk.Saat1
                                                "
                                                :label="$t('Opening-Hours')"
                                                prepend-icon="access_time"
                                                v-on="on"
                                              ></v-text-field>
                                            </template>
                                            <v-time-picker
                                              v-if="menu2"
                                              format="24hr"
                                              v-model="
                                                Satici.stKonsolosluk.Saat1
                                              "
                                              full-width
                                              @click:minute="
                                                $refs.menuacilis.save(
                                                  Satici.stKonsolosluk.Saat1
                                                )
                                              "
                                            >
                                            </v-time-picker>
                                          </v-menu>
                                        </v-flex>

                                        <v-flex xs12 pa-1 sm12 md2>
                                          <v-menu
                                            ref="menukapanis"
                                            v-model="menu3"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="
                                              Satici.stKonsolosluk.Saat2
                                            "
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            max-width="290px"
                                            min-width="290px"
                                          >
                                            <template v-slot:activator="{ on }">
                                              <v-text-field
                                                hide-details
                                                v-model="
                                                  Satici.stKonsolosluk.Saat2
                                                "
                                                label="Kapanış Saat"
                                                prepend-icon="access_time"
                                                v-on="on"
                                              >
                                              </v-text-field>
                                            </template>
                                            <v-time-picker
                                              v-if="menu3"
                                              format="24hr"
                                              v-model="
                                                Satici.stKonsolosluk.Saat2
                                              "
                                              full-width
                                              @click:minute="
                                                $refs.menukapanis.save(
                                                  Satici.stKonsolosluk.Saat2
                                                )
                                              "
                                            >
                                            </v-time-picker>
                                          </v-menu>
                                        </v-flex>
                                        <v-flex xs12 pa-1 sm12 md2>
                                          <v-autocomplete
                                            :items="itemsvizetipi"
                                            item-text="text"
                                            item-value="value"
                                            hide-details=""
                                            v-model="
                                              Satici.stKonsolosluk.VizeTip
                                            "
                                            :label="$t('Visa-Type')"
                                          ></v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12 pa-1 sm12 md2>
                                          <v-layout
                                            row
                                            column
                                            full-height
                                            align-center
                                          >
                                            <v-btn
                                              flat
                                              @click="vizetipatama()"
                                              color="info"
                                              > {{ $t('Consulate-Visa-Type-Appointment') }} </v-btn
                                            >
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 pa-1 sm12 md12>
                                      <v-textarea
                                        v-model="
                                          Satici.stKonsolosluk.Gerekliler
                                        "
                                        hide-details
                                        label="Gerekli Belgeler"
                                      ></v-textarea>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout v-if="this.Satici.SaticiTipi == 12" row="" wrap="">
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs12 pa-1 sm12 md3>
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <tarihim
                                            :etiket="$t('Employment-Period-Start')"
                                            :detaygizle="true"
                                            v-model="
                                              Satici.stTurOperatoru.Donem1
                                            "
                                            v-bind:value="
                                              Satici.stTurOperatoru.Donem1
                                            "
                                            v-bind:defaultvalue="'no'"
                                          >
                                          </tarihim>
                                        </v-flex>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <tarihim
                                            :etiket="$t('Employment-Period-End')"
                                            :detaygizle="true"
                                            v-model="
                                              Satici.stTurOperatoru.Donem2
                                            "
                                            v-bind:value="
                                              Satici.stTurOperatoru.Donem2
                                            "
                                            v-bind:defaultvalue="'no'"
                                          >
                                          </tarihim>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 pa-1 sm12 md3>
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <v-autocomplete
                                            :items="itemsdoviztipi"
                                            item-text="Title"
                                            item-value="DovizKod"
                                            hide-details=""
                                            v-model="
                                              Satici.stTurOperatoru.FatPara
                                            "
                                            :label="$t('Invoice-Currency')"
                                            clearable
                                          ></v-autocomplete>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout v-if="this.Satici.SaticiTipi == 15" row="" wrap="">
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs12 pa-1 sm12 md3>
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <v-autocomplete
                                            hide-details=""
                                            clearable
                                            append-icon="search"
                                            :label="$t('Tour-Operator')"
                                            v-model="
                                              Satici.stFeribot.TurOperatoru.kod
                                            "
                                            :items="stateturoperatoru"
                                            item-text="Aciklama"
                                            item-value="Kod"
                                            :search-input.sync="
                                              searchturoperatoru
                                            "
                                            cache-items=""
                                          >
                                            <template
                                              slot="item"
                                              slot-scope="data"
                                            >
                                              {{ data.item.Kod }}-{{
                                                data.item.Aciklama
                                              }}
                                            </template>
                                          </v-autocomplete>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout v-if="this.Satici.SaticiTipi == 16" row="" wrap="">
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs12 pa-1 sm12 md3>
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-1 sm12 md12>
                                          <v-autocomplete
                                            hide-details=""
                                            clearable
                                            append-icon="search"
                                            label="Otel Seçiniz"
                                            v-model="Satici.stGolf.OtelKod.kod"
                                            :items="stateotel"
                                            item-text="Aciklama"
                                            item-value="Kod"
                                            :search-input.sync="searchotel"
                                            cache-items=""
                                          >
                                            <template
                                              slot="item"
                                              slot-scope="data"
                                            >
                                              {{ data.item.Kod }}-{{
                                                data.item.Aciklama
                                              }}
                                            </template>
                                          </v-autocomplete>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab v-if="this.Satici.SaticiTipi == 3" href="#2" ripple>
              Menü
            </v-tab>
            <v-tab-item
              v-if="this.Satici.SaticiTipi == 3"
              :id="'2'"
              style="width: 100%; height: 100%"
            >
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-card flat>
                                    <v-layout row wrap>
                                      <v-flex xs12 pa-2 sm12 md12>
                                        <v-icon medium="" color="grey"
                                          >restaurant_menu</v-icon
                                        >
                                        &nbsp;
                                        <span
                                          class="font-weight-regular grey--text title"
                                          > {{ $t('Menu-Adding') }} </span
                                        >
                                        <v-divider></v-divider>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md2>
                                        <v-text-field
                                          hide-details=""
                                          v-model="RestaurantMenu.Kod"
                                          :label="$t('Menu-Code')"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          v-model="RestaurantMenu.Menu"
                                          :label="$t('Menu-Name')"
                                        >
                                        </v-text-field>
                                      </v-flex>
                                      <v-flex xs12 pb-2 sm4 md4>
                                        <v-layout row fill-height align-center>
                                          <v-btn
                                            @click="menuEkle()"
                                            flat
                                            color="info"
                                          >
                                            <v-icon>add</v-icon> {{$t('Add-to-List')}}
                                          </v-btn>
                                        </v-layout>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>

                                <v-flex xs12 pt-3 sm12 md12>
                                  <v-card flat>
                                    <v-layout row wrap>
                                      <v-flex xs12 pa-2 sm12 md12>
                                        <v-icon medium="" color="grey"
                                          >view_headline</v-icon
                                        >
                                        &nbsp;
                                        <span
                                          class="font-weight-regular grey--text title"
                                          > {{ $t('Menus') }} </span
                                        >
                                        <v-divider></v-divider>
                                      </v-flex>

                                      <v-flex xs12 sm12 md12>
                                        <v-data-table
                                          :headers="headersmenu"
                                          dense
                                          :rows-per-page-items="[50, 100]"
                                          :items="itemsmenu"
                                        >
                                          <template
                                            slot="items"
                                            slot-scope="props"
                                          >
                                            <tr item>
                                              <td class="text-xs-left">
                                                {{ props.item.Kod }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.Menu }}
                                              </td>
                                              <td
                                                class="justify-center layout px-0"
                                              >
                                                <!-- <v-btn icon class="mx-0" @click="tahsilatgetir(props.item)">
                                                  <v-icon color="teal">edit</v-icon>
                                                </v-btn> -->
                                                <v-btn
                                                  icon
                                                  class="mx-0"
                                                  @click="menuSil(props.item)"
                                                >
                                                  <v-icon color="pink"
                                                    >delete</v-icon
                                                  >
                                                </v-btn>
                                              </td>
                                            </tr>
                                          </template>
                                        </v-data-table>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab v-if="this.Satici.SaticiTipi == 4" href="#3" ripple>
              {{ $t('Tours') }}
            </v-tab>
            <v-tab-item
              v-if="this.Satici.SaticiTipi == 4"
              :id="'3'"
              style="width: 100%; height: 100%"
            >
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md4>
                                  <v-card flat>
                                    <v-layout row wrap>
                                      <v-flex xs12 pa-2 sm12 md12>
                                        <v-icon medium="" color="grey"
                                          >departure_board</v-icon
                                        >
                                        &nbsp;
                                        <span
                                          class="font-weight-regular grey--text title"
                                          > {{ $t('Tour-Adding') }} </span
                                        >
                                        <v-divider></v-divider>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md4>
                                        <v-text-field
                                          hide-details=""
                                          v-model="Turlar.Kod"
                                          :label="$t('Tour-Code-v2')"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md8>
                                        <v-text-field
                                          hide-details=""
                                          v-model="Turlar.Aciklama"
                                          :label="$t('Description')"
                                        >
                                        </v-text-field>
                                      </v-flex>
                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          v-model="Turlar.Tip"
                                          :label="$t('Tour-type-v2')"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          v-model="Turlar.Yer"
                                          :label="$t('Location-v2')"
                                        >
                                        </v-text-field>
                                      </v-flex>
                                      <v-flex pa-1 xs12 sm12 md6>
                                        <tarihim
                                          :etiket="$t('Term-Start')"
                                          :detaygizle="true"
                                          v-model="Turlar.DonemBas"
                                          v-bind:value="Turlar.DonemBas"
                                          v-bind:defaultvalue="'no'"
                                        ></tarihim>
                                      </v-flex>
                                      <v-flex pa-1 xs12 sm12 md6>
                                        <tarihim
                                          :etiket="$t('Term-End')"
                                          :detaygizle="true"
                                          v-model="Turlar.DonemBit"
                                          v-bind:value="Turlar.DonemBit"
                                          v-bind:defaultvalue="'no'"
                                        ></tarihim>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          v-model="Turlar.Yaz"
                                          label="Yaz Adet"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          v-model="Turlar.Kis"
                                          label="Kış Adet"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pb-2 sm12 md12>
                                        <v-layout
                                          row
                                          fill-height
                                          justify-end
                                          align-center
                                        >
                                          <v-btn
                                            @click="turEkle()"
                                            flat
                                            color="info"
                                          >
                                            <v-icon>add</v-icon> {{$t('Add-to-List')}}
                                          </v-btn>
                                        </v-layout>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>

                                <v-flex xs12 pl-2 sm12 md8>
                                  <v-card flat>
                                    <v-layout row wrap>
                                      <v-flex xs12 pa-2 sm12 md12>
                                        <v-icon medium="" color="grey"
                                          >view_headline</v-icon
                                        >
                                        &nbsp;
                                        <span
                                          class="font-weight-regular grey--text title"
                                          >  {{ $t('Tours') }} </span
                                        >
                                        <v-divider></v-divider>
                                      </v-flex>

                                      <v-flex xs12 sm12 md12>
                                        <v-data-table
                                          :headers="headerstur"
                                          dense
                                          :rows-per-page-items="[50, 100]"
                                          :items="itemstur"
                                        >
                                          <template
                                            slot="items"
                                            slot-scope="props"
                                          >
                                            <tr item>
                                              <td class="text-xs-left">
                                                {{ props.item.Kod }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.Aciklama }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{
                                                  props.item.DonemBas
                                                    | dateformat
                                                }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{
                                                  props.item.DonemBit
                                                    | dateformat
                                                }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.Yaz }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.Kis }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.Tip }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.Yer }}
                                              </td>

                                              <td
                                                class="justify-center layout px-0"
                                              >
                                                <!-- <v-btn icon class="mx-0" @click="tahsilatgetir(props.item)">
                                                  <v-icon color="teal">edit</v-icon>
                                                </v-btn> -->
                                                <v-btn
                                                  icon
                                                  class="mx-0"
                                                  @click="turSil(props.item)"
                                                >
                                                  <v-icon color="pink"
                                                    >delete</v-icon
                                                  >
                                                </v-btn>
                                              </td>
                                            </tr>
                                          </template>
                                        </v-data-table>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab v-if="this.Satici.SaticiTipi == 10" href="#4" ripple>
               {{ $t('Acitivity') }}
            </v-tab>
            <v-tab-item
              v-if="this.Satici.SaticiTipi == 10"
              :id="'4'"
              style="width: 100%; height: 100%"
            >
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md4>
                                  <v-card flat>
                                    <v-layout row wrap>
                                      <v-flex xs12 pa-2 sm12 md12>
                                        <v-icon medium="" color="grey"
                                          >chrome_reader_mode</v-icon
                                        >
                                        &nbsp;
                                        <span
                                          class="font-weight-regular grey--text title"
                                          > {{ $t('Activity-Adding') }} </span
                                        >
                                        <v-divider></v-divider>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md4>
                                        <v-text-field
                                          hide-details=""
                                          v-model="Aktivite.Kod"
                                          :label="$t('Code')"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md8>
                                        <v-text-field
                                          hide-details=""
                                          v-model="Aktivite.Aciklama"
                                          :label="$t('Description')"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex pa-1 xs12 sm12 md6>
                                        <tarihim
                                          :etiket="$t('Term-Start')"
                                          :detaygizle="true"
                                          v-model="Aktivite.DonemBas"
                                          v-bind:value="Aktivite.DonemBas"
                                          v-bind:defaultvalue="'no'"
                                        ></tarihim>
                                      </v-flex>
                                      <v-flex pa-1 xs12 sm12 md6>
                                        <tarihim
                                          :etiket="$t('Term-End')"
                                          :detaygizle="true"
                                          v-model="Aktivite.DonemBit"
                                          v-bind:value="Aktivite.DonemBit"
                                          v-bind:defaultvalue="'no'"
                                        ></tarihim>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          v-model="Aktivite.Yaz"
                                          label="Yaz Adet"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          v-model="Aktivite.Kis"
                                          label="Kış Adet"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pb-2 sm12 md12>
                                        <v-layout
                                          row
                                          fill-height
                                          justify-end
                                          align-center
                                        >
                                          <v-btn
                                            @click="aktiviteEkle()"
                                            flat
                                            color="info"
                                          >
                                            <v-icon>add</v-icon>{{$t('Add-to-List')}}
                                          </v-btn>
                                        </v-layout>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>

                                <v-flex xs12 pl-2 sm12 md8>
                                  <v-card flat>
                                    <v-layout row wrap>
                                      <v-flex xs12 pa-2 sm12 md12>
                                        <v-icon medium="" color="grey"
                                          >view_headline</v-icon
                                        >
                                        &nbsp;
                                        <span
                                          class="font-weight-regular grey--text title"
                                          > {{$t('Activities')}} </span
                                        >
                                        <v-divider></v-divider>
                                      </v-flex>

                                      <v-flex xs12 sm12 md12>
                                        <v-data-table
                                          :headers="headersaktivite"
                                          dense
                                          :rows-per-page-items="[50, 100]"
                                          :items="itemsaktivite"
                                        >
                                          <template
                                            slot="items"
                                            slot-scope="props"
                                          >
                                            <tr item>
                                              <td class="text-xs-left">
                                                {{ props.item.Kod }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.Aciklama }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{
                                                  props.item.DonemBas
                                                    | dateformat
                                                }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{
                                                  props.item.DonemBit
                                                    | dateformat
                                                }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.Yaz }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.Kis }}
                                              </td>

                                              <td
                                                class="justify-center layout px-0"
                                              >
                                                <!-- <v-btn icon class="mx-0" @click="tahsilatgetir(props.item)">
                                                  <v-icon color="teal">edit</v-icon>
                                                </v-btn> -->
                                                <v-btn
                                                  icon
                                                  class="mx-0"
                                                  @click="
                                                    aktiviteSil(props.item)
                                                  "
                                                >
                                                  <v-icon color="pink"
                                                    >delete</v-icon
                                                  >
                                                </v-btn>
                                              </td>
                                            </tr>
                                          </template>
                                        </v-data-table>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab v-if="this.Satici.SaticiTipi == 4" href="#5" ripple>
               {{ $t('Transfer-Transportation') }}
            </v-tab>
            <v-tab-item
              v-if="this.Satici.SaticiTipi == 4"
              :id="'5'"
              style="width: 100%; height: 100%"
            >
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md4>
                                  <v-card flat>
                                    <v-layout row wrap>
                                      <v-flex xs12 pa-2 sm12 md12>
                                        <v-icon medium="" color="grey"
                                          >airport_shuttle</v-icon
                                        >
                                        &nbsp;
                                        <span
                                          class="font-weight-regular grey--text title"
                                          >Transfer / Taşımacılık Ekleme</span
                                        >
                                        <v-divider></v-divider>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md4>
                                        <v-text-field
                                          hide-details=""
                                          v-model="TraTas.Kod"
                                          :label="$t('Code')"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md8>
                                        <v-text-field
                                          hide-details=""
                                          v-model="TraTas.Aciklama"
                                          :label="$t('Description')"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pb-2 sm12 md12>
                                        <v-layout
                                          row
                                          fill-height
                                          justify-end
                                          align-center
                                        >
                                          <v-btn
                                            @click="tratasEkle()"
                                            flat
                                            color="info"
                                          >
                                            <v-icon>add</v-icon> {{$t('Add-to-List')}}
                                          </v-btn>
                                        </v-layout>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>

                                <v-flex xs12 pl-2 sm12 md8>
                                  <v-card flat>
                                    <v-layout row wrap>
                                      <v-flex xs12 pa-2 sm12 md12>
                                        <v-icon medium="" color="grey"
                                          >view_headline</v-icon
                                        >
                                        &nbsp;
                                        <span
                                          class="font-weight-regular grey--text title"
                                          > {{ $t('Transfer-Transportation-v2') }} </span
                                        >
                                        <v-divider></v-divider>
                                      </v-flex>

                                      <v-flex xs12 sm12 md12>
                                        <v-data-table
                                          :headers="headerstransfertas"
                                          dense
                                          :rows-per-page-items="[50, 100]"
                                          :items="itemstransfertas"
                                        >
                                          <template
                                            slot="items"
                                            slot-scope="props"
                                          >
                                            <tr item>
                                              <td class="text-xs-left">
                                                {{ props.item.Kod }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.Aciklama }}
                                              </td>

                                              <td
                                                class="justify-center layout px-0"
                                              >
                                                <!-- <v-btn icon class="mx-0" @click="tahsilatgetir(props.item)">
                                                  <v-icon color="teal">edit</v-icon>
                                                </v-btn> -->
                                                <v-btn
                                                  icon
                                                  class="mx-0"
                                                  @click="tratasSil(props.item)"
                                                >
                                                  <v-icon color="pink"
                                                    >delete</v-icon
                                                  >
                                                </v-btn>
                                              </td>
                                            </tr>
                                          </template>
                                        </v-data-table>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab v-if="this.Satici.SaticiTipi == 1" href="#6" ripple>
              {{$t('Definitions-v2')}}
            </v-tab>
            <v-tab-item
              v-if="this.Satici.SaticiTipi == 1"
              :id="'6'"
              style="width: 100%; height: 100%"
            >
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex pa-1 xs12 sm12 md4>
                                  <v-card color="grey lighten-5" flat>
                                    <v-layout row wrap>
                                      <v-flex xs12 pa-1 sm12 md12>
                                        <v-textarea
                                          v-model="Satici.stOtel.BarLokanta"
                                          :label="$t('Bar-and-Restaurant')"
                                        >
                                        </v-textarea>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md12>
                                        <v-textarea
                                          v-model="Satici.stOtel.KonferansOda"
                                          :label="$t('Conference-Halls')"
                                        >
                                        </v-textarea>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>

                                <v-flex xs12 pa-1 sm12 md4>
                                  <v-card color="grey lighten-5" flat>
                                    <v-layout row wrap>
                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          mask="#######"
                                          v-model="Satici.stOtel.MinKisi"
                                          :label="$t('Minimum-Person-Number')"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          mask="#######"
                                          v-model="Satici.stOtel.OpSure"
                                          label="Opsiyon Süresi"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          mask="#######"
                                          v-model="Satici.stOtel.Bedava1"
                                          label="Bedava1"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          mask="#######"
                                          v-model="Satici.stOtel.Bedava2"
                                          label="Bedava2"
                                        >
                                        </v-text-field>
                                      </v-flex>
                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          mask="#######"
                                          v-model="Satici.stOtel.Cocuk1"
                                          label="Çocuk1"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          mask="#######"
                                          v-model="Satici.stOtel.Cocuk2"
                                          label="Çocuk2"
                                        >
                                        </v-text-field>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>

                                <v-flex xs12 pa-1 sm12 md4>
                                  <v-card flat>
                                    <v-form
                                      ref="formodakonum"
                                      v-model="validodakonum"
                                      lazy-validation
                                    >
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-2 sm12 md12>
                                          <v-icon medium="" color="grey"
                                            >location_on</v-icon
                                          >
                                          &nbsp;
                                          <span
                                            class="font-weight-regular grey--text title"
                                            >Oda Konumu Ekle</span
                                          >
                                          <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 pa-1 sm12 md6>
                                          <v-text-field
                                            hide-details=""
                                            v-model="OdaKonum.Isim"
                                            :label="$t('Room-Location')"
                                          >
                                          </v-text-field>
                                        </v-flex>

                                        <v-flex xs12 pa-1 sm12 md6>
                                          <v-text-field
                                            hide-details=""
                                            mask="#######"
                                            v-model="OdaKonum.Adet"
                                            :label="$t('Number')"
                                          >
                                          </v-text-field>
                                        </v-flex>

                                        <v-flex xs12 pb-2 sm12 md12>
                                          <v-layout
                                            row
                                            fill-height
                                            justify-end
                                            align-center
                                          >
                                            <v-btn
                                              @click="odakonumEkle()"
                                              flat
                                              color="info"
                                            >
                                              <v-icon>add</v-icon> {{$t('Add-to-List')}}
                                            </v-btn>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 pa-2 sm12 md12>
                                          <v-icon medium="" color="grey"
                                            >view_headline</v-icon
                                          >
                                          &nbsp;
                                          <span
                                            class="font-weight-regular grey--text title"
                                            > {{ $t('Room-Locations') }} </span
                                          >
                                          <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                          <v-data-table
                                            :headers="headersodakonum"
                                            dense
                                            :rows-per-page-items="[50, 100]"
                                            :items="itemsodakonum"
                                          >
                                            <template
                                              slot="items"
                                              slot-scope="props"
                                            >
                                              <tr item>
                                                <td class="text-xs-left">
                                                  {{ props.item.Isim }}
                                                </td>
                                                <td class="text-xs-left">
                                                  {{ props.item.Adet }}
                                                </td>

                                                <td
                                                  class="justify-center layout px-0"
                                                >
                                                  <!-- <v-btn icon class="mx-0" @click="tahsilatgetir(props.item)">
                                                  <v-icon color="teal">edit</v-icon>
                                                </v-btn> -->
                                                  <v-btn
                                                    icon
                                                    class="mx-0"
                                                    @click="
                                                      odakonumSil(props.item)
                                                    "
                                                  >
                                                    <v-icon color="pink"
                                                      >delete</v-icon
                                                    >
                                                  </v-btn>
                                                </td>
                                              </tr>
                                            </template>
                                          </v-data-table>
                                        </v-flex>
                                      </v-layout>
                                    </v-form>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab v-if="this.Satici.SaticiTipi == 9" href="#6" ripple>
              {{$t('Definitions-v2')}}
            </v-tab>
            <v-tab-item
              v-if="this.Satici.SaticiTipi == 9"
              :id="'6'"
              style="width: 100%; height: 100%"
            >
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex pa-1 xs12 sm12 md4>
                                  <v-card flat>
                                    <v-layout row wrap>
                                      <v-flex xs12 pa-1 sm12 md12>
                                        <v-textarea
                                          v-model="Satici.stGemi.BarLokanta"
                                          :label="$t('Bar-and-Restaurant')"
                                        >
                                        </v-textarea>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md12>
                                        <v-textarea
                                          v-model="Satici.stGemi.KonferansOda"
                                          :label="$t('Conference-Halls')"
                                        >
                                        </v-textarea>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>

                                <v-flex xs12 pa-1 sm12 md4>
                                  <v-card flat>
                                    <v-layout row wrap>
                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          mask="#######"
                                          v-model="Satici.stGemi.MinKisi"
                                          :label="$t('Minimum-Person-Number')"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          mask="#######"
                                          v-model="Satici.stGemi.OpSure"
                                          label="Opsiyon Süresi"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          mask="#######"
                                          v-model="Satici.stGemi.Bedava1"
                                          label="Bedava1"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          mask="#######"
                                          v-model="Satici.stGemi.Bedava2"
                                          label="Bedava2"
                                        >
                                        </v-text-field>
                                      </v-flex>
                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          mask="#######"
                                          v-model="Satici.stGemi.Cocuk1"
                                          :label="$t('Child') + '1'"
                                        >
                                        </v-text-field>
                                      </v-flex>

                                      <v-flex xs12 pa-1 sm12 md6>
                                        <v-text-field
                                          hide-details=""
                                          mask="#######"
                                          v-model="Satici.stGemi.Cocuk2"
                                          :label="$t('Child') + '2'"
                                        >
                                        </v-text-field>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>

                                <v-flex xs12 pa-1 sm12 md4>
                                  <v-card flat>
                                    <v-form
                                      ref="formgemiodakonum"
                                      v-model="validgemiodakonum"
                                      lazy-validation
                                    >
                                      <v-layout row wrap>
                                        <v-flex xs12 pa-2 sm12 md12>
                                          <v-icon medium="" color="grey"
                                            >location_on</v-icon
                                          >
                                          &nbsp;
                                          <span
                                            class="font-weight-regular grey--text title"
                                            >Oda Konumu Ekle</span
                                          >
                                          <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 pa-1 sm12 md6>
                                          <v-text-field
                                            hide-details=""
                                            v-model="OdaKonum.Isim"
                                            :label="$t('Room-Location')"
                                          >
                                          </v-text-field>
                                        </v-flex>

                                        <v-flex xs12 pa-1 sm12 md6>
                                          <v-text-field
                                            hide-details=""
                                            mask="#######"
                                            v-model="OdaKonum.Adet"
                                            :label="$t('Number')"
                                          >
                                          </v-text-field>
                                        </v-flex>

                                        <v-flex xs12 pb-2 sm12 md12>
                                          <v-layout
                                            row
                                            fill-height
                                            justify-end
                                            align-center
                                          >
                                            <v-btn
                                              @click="gemiodakonumEkle()"
                                              flat
                                              color="info"
                                            >
                                              <v-icon>add</v-icon> {{$t('Add-to-List')}}
                                            </v-btn>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 pa-2 sm12 md12>
                                          <v-icon medium="" color="grey"
                                            >view_headline</v-icon
                                          >
                                          &nbsp;
                                          <span
                                            class="font-weight-regular grey--text title"
                                            > {{ $t('Room-Locations') }} </span
                                          >
                                          <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                          <v-data-table
                                            :headers="headersodakonum"
                                            dense
                                            :rows-per-page-items="[50, 100]"
                                            :items="itemsgemiodakonum"
                                          >
                                            <template
                                              slot="items"
                                              slot-scope="props"
                                            >
                                              <tr item>
                                                <td class="text-xs-left">
                                                  {{ props.item.Isim }}
                                                </td>
                                                <td class="text-xs-left">
                                                  {{ props.item.Adet }}
                                                </td>

                                                <td
                                                  class="justify-center layout px-0"
                                                >
                                                  <!-- <v-btn icon class="mx-0" @click="tahsilatgetir(props.item)">
                                                  <v-icon color="teal">edit</v-icon>
                                                </v-btn> -->
                                                  <v-btn
                                                    icon
                                                    class="mx-0"
                                                    @click="
                                                      gemiodakonumSil(
                                                        props.item
                                                      )
                                                    "
                                                  >
                                                    <v-icon color="pink"
                                                      >delete</v-icon
                                                    >
                                                  </v-btn>
                                                </td>
                                              </tr>
                                            </template>
                                          </v-data-table>
                                        </v-flex>
                                      </v-layout>
                                    </v-form>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab href="#7" ripple> {{$t('Descriptions')}} </v-tab>
            <v-tab-item :id="'7'">
              <v-flex pa-1 xs12 sm12 md12>
                <v-card class="white--text">
                  <v-card color="grey lighten-4" flat="">
                    <v-card-actions>
                      <v-layout row="" wrap="">
                        <v-flex xs12 sm12 md12>
                          <v-layout justify-space-between column>
                            <v-textarea
                              hide-details=""
                              v-model="Satici.Aciklamalar"
                              :label="$t('Notes')"
                            ></v-textarea>
                            <v-textarea
                              hide-details=""
                              v-model="Satici.LocationF"
                              :label="$t('Transportation-Location-Features')"
                            >
                            </v-textarea>
                            <v-textarea
                              hide-details=""
                              v-model="Satici.OdaTanimlari"
                              :label="$t('Room-Allocation')"
                            >
                            </v-textarea>
                            <v-textarea
                              hide-details=""
                              v-model="Satici.OtelOzellikleri"
                              :label="$t('Seller-Features')"
                            >
                            </v-textarea>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
            </v-tab-item>

          </v-tabs>

          <v-dialog v-model="addNeighborhoodDialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline">Semt Ekle</v-card-title>
              <v-card-text
                >
                <v-text-field
                  label="Semt"
                  v-model="Neighborhood"
                ></v-text-field>
                </v-card-text
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" flat @click.native="addNeighborhoodDialog = false">{{
                  $t("cancel_button")
                }}</v-btn>

                <v-btn v-if="satirsilbtn" color="info" flat @click="addNeighborhood()"
                  >{{ $t('OK') }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="addDistinctDialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline">İlçe Ekle</v-card-title>
              <v-card-text
                >
                <v-text-field
                  label="İlçe"
                  v-model="distinct"
                ></v-text-field>
                </v-card-text
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" flat @click.native="addDistinctDialog = false">{{
                  $t("cancel_button")
                }}</v-btn>

                <v-btn v-if="satirsilbtn" color="info" flat @click="addDistrict()"
                  >{{ $t('OK') }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>


          <v-dialog v-model="dialogsor" persistent max-width="290">
            <v-card>
              <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
              <v-card-text
                >Bu kayıtı silmek istediğinize emin misiniz?</v-card-text
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" flat @click.native="dialogsor = false">{{
                  $t("cancel_button")
                }}</v-btn>

                <v-btn v-if="satirsilbtn" color="info" flat @click="satirsil()"
                  >{{ $t('OK') }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-form>
      <template>
        <v-card>
          <v-snackbar
            :timeout="timeout"
            :top="y === 'top'"
            :bottom="y === 'bottom'"
            :right="x === 'right'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'"
            v-model="snackbar"
          >
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false"
              >{{$t('Close')}}</v-btn
            >
          </v-snackbar>
        </v-card>
      </template>
    </v-card>
  </div>
</template>

<script>
import auth from "../../../../api/auth";
import parainput from "../../customcomp/parainput";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue";
import tool from "../../coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";
import rezervasyonekleridialog from "@/components/app/coper/component/rezervasyonekleridialog.vue";
import dosyaekleridialog from "@/components/app/coper/component/dosyaekleridialog.vue";
import vizetipekledialog from "@/components/app/coper/component/vizetipekledialog.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp";

export default {
  props: {
    operation: "",
  },

  data() {
    return {
      Neighborhood:null,
      addNeighborhoodDialog:false,
      addDistinctDialog:false,
      distinct:null,
      counter:0,
      Satici: {
        tumSirketler:false,
        SaticiTipi: 0,
        Ref: null,
        SirketNo: null,
        Kod: null,
        Isim: null,
        Cari_Kod: {
          id: null,
          kod: null,
          isim: null,
        },
        Adres: null,
        PK: null,
        Ulke: null,
        Sehir: null,
        Yer: null,
        SaticiKonumu: null,
        Yetkili: null,
        Web: null,
        HavaAlani: null,
        VDaire: null,
        VNo: null,
        Tel1: null,
        Tel2: null,
        Fax: null,
        Teleks: null,
        Email: null,
        GSM: null,
        Ic_Dis: "0",
        Aciklamalar: null,
        LocationF: null,
        OdaTanimlari: null,
        OtelOzellikleri: null,
        krdDerece: null,
        krdDakika: null,
        krdSaniye: null,
        krdDereceM: null,
        krdDakikaM: null,
        krdSaniyeM: null,
        Grup: null,
        PasifKayit: false,
        GlobalKod: null,
        ZincirKodu: null,
        CreatedBy: null,
        CreatedDate: null,
        ModifiedBy: null,
        ModifiedDate: null,
        AutoCreate: null,
        stOtel: {
          Ucretsizler: [],
          Ucretliler: [],
          Kategori: null,
          GenelMudur: null,
          SatisMuduru: null,
          MuhasebeMuduru: null,
          Donem1: null,
          Donem2: null,
          BarLokanta: null,
          KonferansOda: null,
          OdaKonum: [],
          MinKisi: null,
          OpSure: null,
          Bedava1: null,
          Bedava2: null,
          Cocuk1: null,
          Cocuk2: null,
          OtelTip: null,
          AutoCreate: null,
        },
        stArac: {
          AracTipi: [],
          Donem1: null,
          Donem2: null,
        },
        stRestaurant: {
          KisiYaz: 0,
          KisiKis: 0,
          MinKisi: 0,
          Sorumlu1: null,
          Sorumlu2: null,
          Sinif: null,
          Donem1: null,
          Donem2: null,
          Menu: [],
        },
        stAcente: {
          AcenteTipi: null,
          Sorumlu1: null,
          Sorumlu2: null,
          Donem1: null,
          Donem2: null,
          Turlar: [],
          TransferTasima: [],
          AcenteTip: 0, //0 merkez- 1 tali
          Kurumsal: false,
          Parola: null,
          AnaAcenteKod: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
        },
        stRentACar: {
          AracTipi: [],
          Donem1: null,
          Donem2: null,
          Araclar: [],
        },
        stRehber: {
          Diller: [],
          Cinsiyet: 0,
          Sinif: null,
          Donem1: null,
          Donem2: null,
        },

        stMuze: {
          Donem1: null,
          Donem2: null,
          AcikGunler: {
            Pazartesi: false,
            Sali: false,
            Carsamba: false,
            Persembe: false,
            Cuma: false,
            Cumartesi: false,
            Pazar: false,
          },
          AcikSaat1: null,
          AcikSaat2: null,
          AcikSaat3: null,
        },
        stCharter: {
          Ucaklar: [],
          Donem1: null,
          Donem2: null,
          OpSure: 0,
          FormNo: null,
          HY_Kodu: null,
          Parkur: [],
        },
        stGemi: {
          Ucretsizler: [],
          Ucretliler: [],
          Kategori: null,
          GenelMudur: null,
          SatisMuduru: null,
          MuhasebeMuduru: null,
          Donem1: null,
          Donem2: null,
          BarLokanta: null,
          KonferansOda: null,
          OdaKonum: [],
          MinKisi: null,
          OpSure: null,
          Bedava1: null,
          Bedava2: null,
          Cocuk1: null,
          Cocuk2: null,
          OtelTip: null,
          AutoCreate: null,
        },
        stDiger: {
          Donem1: null,
          Donem2: null,
          Aktivite: [],
        },
        stTurOperatoru: {
          FatPara: null,
          Donem1: null,
          Donem2: null,
        },
        stKonsolosluk: {
          Saat1: null,
          Saat2: null,
          Gerekliler: null,
          VizeTip: 0,
        },
        stSigorta: null,
        stFeribot: {
          TurOperatoru: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
        },
        stGolf: {
          OtelKod: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
        },
      },

      AracTipleri: null,
      secilenacente: null,

      ulkeTipi: [],
      sehirTipi: [],
      ilceTipi: [],
      semtTipi: [],
      saticiTipi: [
        {
          text: "Yurtiçi",
          value: 0,
        },
        {
          text: "Yurtdışı",
          value: 1,
        },
      ],

      Aractipi: {
        AnaTip: null,
        AltTip: null,
        AracAdi: null,
        YazEnAz: 0,
        YazEnCok: 0,
        KisEnAz: 0,
        KisEnCok: 0,
      },
      RestaurantMenu: {
        Kod: null,
        Menu: null,
      },
      OdaKonum: {
        Isim: null,
        Adet: 0,
      },
      Turlar: {
        Kod: null,
        Aciklama: null,
        DonemBas: null,
        DonemBit: null,
        Yaz: 0,
        Kis: 0,
        Tip: null,
        Yer: null,
      },
      Aktivite: {
        Kod: null,
        Aciklama: null,
        DonemBas: null,
        DonemBit: null,
        Yaz: 0,
        Kis: 0,
      },

      TraTas: {
        Kod: null,
        Aciklama: null,
      },
      RentACar: {
        Id: null,
        Kategori: null,
        Kod: null,
        Marka: null,
        Model: null,
        AracAd: null,
        Plaka: null,
        SaatOpsiyonu: 0,
        YakitTipi: "0",
        Adet: 0,
        Deleted: false,
      },
      validrentacar: true,
      validodakonum: true,
      validgemiodakonum: true,

      sinifekleview: false,
      valid: true,
      ucretsizOzellikler: [],
      aracOzelliklertumList: [],
      ucretsizler: null,
      ucretsizOzelliklertumList: [],

      ucretliOzellikler: [],
      ucretliler: null,
      ucretliOzelliklertumList: [],
      kategoriitems: [],
      guncellbtn: false,
      satirsilbtn: true,
      silinecekkayit: null,
      dialogsor: false,
      headersarac: [
        {
          text: this.$t('Main-Type'),
          value: "AnaTip",
        },
        {
          text: this.$t('Sub-Type'),
          value: "AltTip",
        },
        {
          text: this.$t('Vehicle-Name'),
          value: "AracAdi",
        },
        {
          text: this.$t('Summer-Least'),
          value: "YazEnAz",
        },
        {
          text: this.$t('Summer-Most'),
          value: "YazEnCok",
        },
        {
          text: this.$t('Winter-Least'),
          value: "KisEnAz",
        },
        {
          text: this.$t('Winter-Most'),
          value: "KisEnCok",
        },
      ],
      itemsarac: [],
      headersmenu: [
        {
          text: "Kod",
          value: "Kod",
        },
        {
          text: this.$t('Menu-Name'),
          value: "Menu",
        },
      ],
      headersodakonum: [
        {
          text: "Konum",
          value: "Isim",
        },
        {
          text: this.$t('Number'),
          value: "Adet",
        },
      ],
      itemsodakonum: [],
      itemsgemiodakonum: [],

      itemsmenu: [],

      headerstur: [
        {
          text: "Kod",
          value: "Kod",
        },
        {
          text: this.$t('Description'),
          value: "Aciklama",
        },
        {
          text: "Dönem Baş.",
          value: "DonemBas",
        },
        {
          text: "Dönem Bit.",
          value: "DonemBit",
        },
        {
          text: "Yaz Adet",
          value: "Yaz",
        },
        {
          text: "Kış Adet",
          value: "Kis",
        },
        {
          text: "Tip",
          value: "Tip",
        },
        {
          text: this.$t('Location-v2'),
          value: "Yer",
        },
      ],
      itemstransfertas: [],
      headerstransfertas: [
        {
          text: this.$t('Code'),
          value: "Kod",
        },
        {
          text: this.$t('Description'),
          value: "Aciklama",
        },
      ],
      headersaktivite: [
        {
          text: this.$t('Code'),
          value: "Kod",
        },
        {
          text: this.$t('Description'),
          value: "Aciklama",
        },
        {
          text: "Dönem Baş.",
          value: "DonemBas",
        },
        {
          text: "Dönem Bit.",
          value: "DonemBit",
        },
        {
          text: "Yaz Adet",
          value: "Yaz",
        },
        {
          text: "Kış Adet",
          value: "Kis",
        },
      ],
      itemsaktivite: [],

      itemstur: [],
      itemsaracsinifi: [],
      yenisinif: null,
      itemsarackategori: [],
      itemsaracmarka: [],
      itemsaracmodel: [],
      itemsyakittipi: [
        {
          text: "Benzin",
          value: "0",
        },
        {
          text: "Diesel",
          value: "1",
        },
        {
          text: "LPG",
          value: "2",
        },
        {
          text: "Hybrid",
          value: "3",
        },
      ],
      headersrentacarliste: [
        {
          text: this.$t('Category'),
          value: "Kategori",
        },
        {
          text: this.$t('Code'),
          value: "Kod",
        },
        {
          text: this.$t('Brand'),
          value: "Marka",
        },
        {
          text: "Model",
          value: "Model",
        },
        {
          text: this.$t('Vehicle-Name'),
          value: "AracAd",
        },
        {
          text: "Plaka",
          value: "Plaka",
        },
        {
          text: this.$t('Number'),
          value: "Adet",
        },
      ],
      itemsrentacarliste: [],

      itemsdiller: [
        {
          Check: true,
          Dil: "Fransızca",
        },
        {
          Check: true,
          Dil: "Ingilizce",
        },
        {
          Check: false,
          Dil: "HERTZ",
        },
        {
          Check: true,
          Dil: "EUROPCAR",
        },
      ],
      itemsvizetipi: [
        {
          text: "USA",
          value: 0,
        },
        {
          text: "CHANGEN",
          value: 1,
        },
        {
          text: "MUNFERIT",
          value: 2,
        },
        {
          text: "KONSOLOSLUK_OZEL",
          value: 3,
        },
      ],

      rehberbildigiDiller: [],

      menu2: false,
      menu3: false,
      itemsdoviztipi: [],
      itemsformno: [],
      itemshavayolu: [],

      headeraktarim: [
        {
          text: this.$t('Currentcode_label'),
          value: "CariKodu",
        },
        {
          text: this.$t('Airline-Code'),
          value: "HavayoluKodu",
        },
        {
          text: this.$t('Transfer-Code-v2'),
          value: "AktarimKodu",
        },
        {
          text: this.$t('Process'),
          value: "",
          align: "right",
        },
      ],
      aktarimitems: [],
      loadingacente: false,
      stateacente: [],
      stateotel: [],
      searchacente: null,
      searchotel: null,

      stateturoperatoru: [],
      searchturoperatoru: null,
      aktarimKodu: null,
      havayoluLabel: "AKTARIM KODU",
      havayolukodu: null,
      itemsairlinelist: [
        {
          Title: "H9 - PEGASUS",
          HavaYoluKodu: "H9",
        },
      ],
      hesapgurubu: [],
      dialogfiltre: false,

      cokluposta: false,
      postaitems: [],
      valid: true,
      defaultvalue: 0,
      efaturami: false,
      drawer: null,
      baslik: "",
      e1: 0,
      Code: "",
      e2: true,
      yok: false,
      statecari: [],
      search: "",
      search1: "",
      loading: false,
      Current: {
        CompanyCode: "",
        Code: null,
        Title: null,
        Phone1: "",
        Phone2: "",
        Mobile: "",
        Web: "",
        Email: "",
        AccountGroup: "",
        AccountingCode: null,
        Type: "",
        CMCode: "",
        Reserved1: "",
        Reserved2: "",
        Authorized: "",
        WarningNote: "",
        InfoNote: "",
        CustomerType: "",
        TicketBill: "",
        EInvoiceType: "0",
        PostCodeLabel: "",
        EInvoiceCustomer: "",
        MultiPostUse: "",
        EArchiveSendType: false,
        EArchiveSendPaper: false,
        CreditLimit: 0,
        CreditLimitCurrencyAmount: "",
        CreditLimitCurrency: "",
        WebPassword: "",
        PinCode: "",
        MileCode: "",
        ExpiryDayDomestic: "",
        ExpiryTypeDomestic: "",
        ExpiryDayInt: "",
        ExpiryTypeInt: "",
        ExpiryDayGeneral: "",
        ExpiryTypeGeneral: "",
        DiscountGeneral: "",
        DiscountDom: "",
        DiscountInt: "",
        DiscountDomService: "",
        DiscountIntService: "",
        TaxFree: "",
        ExternalCurrentCode: "",
        ExternalAccountingCode: "",
        StreamCurrentCode: "",
        ArkmanStreamCode: "",
        ArkmanStreamPassword: null,
        ExpenseCenter: "",
        TemplateID: "",
        ProfileForced: "",
        EventIDForced: "",
        MainAccount: "",
        Invoice: {
          Address: "",
          PostCode: "",
          Province: "",
          Country: "",
          TaxNumber: "",
          TaxOffice: "",
          IdentityNumber: "",
          PerFirstName: "",
          PerFamilyName: "",
          PerTitle: "",
          PerMiddleName: "",
          PerNameSuffix: "",
          NoPrint: "",
          CustomerPersonelNoInvoice: "",
          DeliveryAddress: "",
          DeliveryName: "",
        },
        Contract: {
          ContractNumber: "",
          ContractDate: "",
          PaymentType: "",
          BankAccountNumber: "",
          BankBranchOffice: "",
          InvoiceRowNumber: "",
          InvoicePassengerName: "",
          InvoiceFlightNumber: "",
        },
      },

      efaturatipi: [
        {
          text: this.$t('Commercial'),
          value: "0",
        },
        {
          text: this.$t('Basic'),
          value: "1",
        },
        {
          text: this.$t('Export'),
          value: "2",
        },
      ],
      islembilgileri: [
        {
          text: this.$t('Hard-Copy-Invoice'),
          value: "false",
        },
        {
          text: this.$t('Electronic-Invoice'),
          value: "true",
        },
      ],
      doviztipi: [],
      ichattipi: [
        "D",
        "D-",
        "D+",
        "K",
        "K-",
        "K+",
        "U",
        "U-",
        "U+",
        "L",
        "L-",
        "L+",
      ],
      evethayir: [
        {
          text: "Evet",
          value: "E",
        },
        {
          text: "Hayır",
          value: "H",
        },
      ],
      cmkodu: ["C", "M"],
      masrafmerkezi: [],
      dictionary: {
        custom: {
          carikod: {
            required: () => this.$t('This-space-cannot-left-blank'),
          },
          unvan: {
            required: () => this.$t('This-space-cannot-left-blank'),
          },
        },
      },
      disyuzde: false,
      icyuzde: false,
      StartDate: null,
      EndDate: null,
      NumberOfPolicies: "",
      PolicySum: "",
      TotalDebt: "",
      TotalFlatDebt: "",
      kaydetbuton: false,
      guncellebuton: false,
      silbuton: false,
      date: null,
      menu: false,
      modal: false,
      dateFormatted: "",
      text1: "",
      ichatdoviztipi1: false,
      ichatdoviztipi2: false,
      ichatdoviztipi3: false,
      ichatdoviztipi4: false,
      ichatdoviztipi5: false,
      dishatdoviztipi1: false,
      dishatdoviztipi2: false,
      dishatdoviztipi3: false,
      dishatdoviztipi4: false,
      dishatdoviztipi5: false,
      dishatdoviztipi6: false,
      dishatdoviztipi7: false,
      biletlerfaturalanmasin: null,
      efaturamukellefi: false,
      Kdvmuaf: null,
      ciktiistemiyor: null,
      musteribilgitipi: null,
      profilzorunlu: null,
      eventidzorunlu: null,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      carikod: "",
      unvan: "",
      active: "",
      ex11: "false",
      tabcontrol3: 0,
      icYuzdedenHesapla: {
        Yuzdeden: false,
        HesapTipi: null,
        HesapYuzde: 0,
      },
      DisYuzdedenHesapla: {
        Yuzdeden: false,
        HesapTipi: null,
        HesapYuzde: 0,
      },
      hesaptipi: [
        {
          text: this.$t('Ticket-Amount'),
          value: 0,
        },
        {
          text: this.$t('Ticket-Amount') + "+"+ this.$t('Taxes'),
          value: 1,
        },
      ],
    };
  },
  mounted() {
    this.$validator.localize("en", this.dictionary);
  },
  computed: {
    allSelected() {
      return this.selected.length === this.itemskategori.length;
    },
    categories() {
      const search = this.search.toLowerCase();

      if (!search) return this.itemskategori;

      return this.itemskategori.filter((item) => {
        const text = item.text.toLowerCase();

        return text.indexOf(search) > -1;
      });
    },
    selections() {
      const selections = [];

      for (const selection of this.selected) {
        selections.push(this.itemskategori[selection]);
      }

      return selections;
    },
  },

  watch: {
    searchacente(val) {
      val && this.acentegetir(val);
    },
    searchotel(val) {
      val && this.otelgetir(val);
    },
    searchturoperatoru(val) {
      val && this.turoperatorugetir(val);
    },
    AracTipleri: function (value) {
      if (value != null) {
        this.Aractipi.AnaTip = value.Ana;
        this.Aractipi.AltTip = value.Alt;
      }
    },

    "RentACar.Marka": function (value) {
      if (value != null) {
        this.aracmodelGetir(value);
      }
    },

    "icYuzdedenHesapla.Yuzdeden": function (value) {
      if (value == true) {
        this.icyuzde = true;
        this.icYuzdedenHesapla.HesapTipi = 0;
      } else {
        this.icyuzde = false;
        this.icYuzdedenHesapla.HesapTipi = null;
      }
    },
    "DisYuzdedenHesapla.Yuzdeden": function (value) {
      if (value == true) {
        this.disyuzde = true;
        this.DisYuzdedenHesapla.HesapTipi = 0;
      } else {
        this.disyuzde = false;
        this.DisYuzdedenHesapla.HesapTipi = null;
      }
    },
    efaturamukellefi: function (value1) {
      if (value1 === true) {
        this.efaturami = true;
      } else {
        this.efaturami = false;
        this.Current.EInvoiceType = null;
        this.Current.PostCodeLabel = null;
        this.Current.MultiPostUse = false;
      }
    },
    active(val1) {
      //tablar aktif olunca değerleri çekelim
    },
  },

  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
  },

  methods: {
    addNeighborhood(){
      if(this.Satici.Yer != null) {

      var distinct = this.ilceTipi.find((x) => x.Isim == this.Satici.Yer);
      var params = {
        IlceId: distinct.Id,
        Isim: this.Neighborhood
        };

        tool.http_post(this, "SemtInsert", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.addNeighborhoodDialog = false;
              this.semtTipi.push(response.body.data);
              this.Satici.SaticiKonumu = this.Neighborhood;
            }else{
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
            }
          },
          (response) => {
            this.text1 = "Service Unavailable-SemtInsert";
            this.snackbar = true;
          }
        );
      }else{
        this.text1 = "İlçe seçimi yapmalısınız.";
        this.snackbar = true;
      }

    },
    addDistrict(){
      if(this.Satici.Sehir != null) {

      var city = this.sehirTipi.find((x) => x.Isim == this.Satici.Sehir);
      var params = {
        IlId: city.Id,
        Isim: this.distinct
        };

        tool.http_post(this, "IlceInsert", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.addDistinctDialog = false;
              this.ilceTipi.push(response.body.data);
              this.Satici.Yer = this.distinct;
            }else{
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
            }
          },
          (response) => {
            this.text1 = "Service Unavailable-IlceInsert";
            this.snackbar = true;
          }
        );
      }else{
        this.text1 = "Şehir seçimi yapmalısınız.";
        this.snackbar = true;
      }

    },
    getTown(value) {
      if (value != null) {
        var IlceId = 0;
        if (value !== value) {
          IlceId = null;
          this.ilceTipi.forEach((element) => {
            if (element.Isim === this.Satici.Yer) {
              IlceId = element.Id;
            }
          });
        } else {
          this.ilceTipi.forEach((element) => {
            if (element.Isim === value) {
              IlceId = element.Id;
            }
          });
        }

        var params = {
          IlceId: IlceId,
        };

        tool.http_post(this, "SemtList", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.semtTipi = response.body.data;
            } else {
            }
          },
          (response) => {
            this.text1 = "Service Unavailable-IlList";
            this.snackbar = true;
          }
        );
      }
    },
    getDistinct(value) {
      if (value != null) {
        var SehirId = 0;
        if (value !== value) {
          SehirId = null;
          this.sehirTipi.forEach((element) => {
            if (element.Isim === this.Satici.Sehir) {
              SehirId = element.Id;
            }
          });
        } else {
          this.sehirTipi.forEach((element) => {
            if (element.Isim === value) {
              SehirId = element.Id;
            }
          });
        }
        var params = {
          IlId: SehirId,
        };

        tool.http_post(this, "IlceList", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.ilceTipi = response.body.data;
              if (this.Satici.Yer != null) {
                this.getTown(this.Satici.Yer);
              }
            } else {
            }
          },
          (response) => {
            this.text1 = "Service Unavailable-IlList";
            this.snackbar = true;
          }
        );
      }
    },
    getCity(value) {
      if (value != null && value !== "undefined") {
        var ulkeId = 0;

        if (value !== value) {
          ulkeId = null;
          this.ulkeTipi.forEach((element) => {
            if (element.Isim === this.Satici.Ulke) {
              ulkeId = element.Id;
            }
          });
        } else {
          this.ulkeTipi.forEach((element) => {
            if (element.Isim === value) {
              ulkeId = element.Id;
            }
          });
        }

        var params = {
          UlkeId: ulkeId,
        };

        tool.http_post(this, "IlList", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.sehirTipi = response.body.data;
              if (this.Satici.Sehir != null) {
                this.getDistinct(this.Satici.Sehir);
              }
            } else {
            }
          },
          (response) => {
            this.text1 = "Service Unavailable-IlList";
            this.snackbar = true;
          }
        );
      }
    },
    dokumanEkler() {
      this.$refs.dosyaekleridialog
        .open(this.Satici.SaticiTipi, this.Satici.Kod)
        .then((sonuc) => {
          if (sonuc == true) {
          }
        });
    },
    vizetipatama() {
      this.$refs.vizetipekledialog
        .open(
          this.Satici.SaticiTipi,
          this.Satici.Kod,
          this.Satici.stKonsolosluk.VizeTip
        )
        .then((sonuc) => {
          if (sonuc == true) {
          }
        });
    },
    rezervasyonekleri() {
      this.$refs.rezervasyonekleridialog
        .open(this.Satici.SaticiTipi, this.Satici.Kod)
        .then((sonuc) => {
          if (sonuc == true) {
          }
        });
    },
    formnoGetir() {
      tool.http_post(this, "AirlineList", {}).then(
        (response) => {
          if (response.body.Status == true) {
            this.itemsformno = response.body.data;
          } else {
            this.text1 = "Service Unavailable-AracMarkaList";
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Service Unavailable-AracMarkaList";
          this.snackbar = true;
        }
      );
    },
    dovizgetir() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var params = {
        CompanyCode: credentials.SirketKodu,
      };
      this.$http
        .post(auth.API_URL + "api/currency/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.itemsdoviztipi = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz Tipi";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz Tipi";
              this.snackbar = true;
            }
          }
        );
    },
    timekontrol(a) {
      if (a == "0001-01-01T00:00:00") {
        return null;
      } else {
        var bastarih = a.split("T");
        if (bastarih[1] != "00:00:00") {
          var saat = bastarih[1].split(":");
          return saat[0] + ":" + saat[1];
        } else {
          return null;
        }
      }
    },
    dizideara(key, inputArray) {
      for (let i = 0; i < inputArray.length; i++) {
        if (inputArray[i].Kod === key) {
          return inputArray[i];
        }
      }
    },
    rentacararacEkle() {
      if (this.$refs.formrentacar.validate()) {
        if (this.itemsrentacarliste.indexOf(this.RentACar.Kod) == -1) {
          var newCar = {
            Id: null,
            Kategori: this.RentACar.Kategori,
            Kod: this.RentACar.Kod,
            Marka: this.RentACar.Marka,
            Model: this.RentACar.Model,
            AracAd: this.RentACar.AracAd,
            Plaka: this.RentACar.Plaka,
            SaatOpsiyonu: this.RentACar.SaatOpsiyonu,
            YakitTipi: this.RentACar.YakitTipi,
            Adet: this.RentACar.Adet,
            Deleted: false,
          };
          this.itemsrentacarliste.push(newCar);
        } else {
          this.text1 = this.$t('list-includes-records-this-vehicle-code');
          this.snackbar = true;
        }
      } else {
        this.text1 = this.$t('Please-fill-required-fields');
        this.snackbar = true;
      }
    },
    rentacarSil(a) {
      this.itemsrentacarliste.splice(this.itemsrentacarliste.indexOf(a), 1);
    },
    odakonumEkle() {
      if (this.$refs.formodakonum.validate()) {
        var kayit = {
          Isim: this.OdaKonum.Isim,
          Adet: this.OdaKonum.Adet,
        };
        this.itemsodakonum.push(kayit);
      } else {
        this.text1 = this.$t('Please-fill-required-fields');
        this.snackbar = true;
      }
    },
    odakonumSil(a) {
      this.itemsodakonum.splice(this.itemsodakonum.indexOf(a), 1);
    },
    gemiodakonumEkle() {
      if (this.$refs.formgemiodakonum.validate()) {
        var kayit = {
          Isim: this.OdaKonum.Isim,
          Adet: this.OdaKonum.Adet,
        };
        this.itemsgemiodakonum.push(kayit);
      } else {
        this.text1 = this.$t('Please-fill-required-fields');
        this.snackbar = true;
      }
    },
    gemiodakonumSil(a) {
      this.itemsgemiodakonum.splice(this.itemsgemiodakonum.indexOf(a), 1);
    },
    sinifEkle() {
      if (this.itemsaracsinifi.indexOf(this.yenisinif) == -1) {
        var a = {
          Kod: this.yenisinif,
        };
        this.itemsaracsinifi.push(a);
      } else {
        this.text1 = this.$t('This-vehicle-class-present')
        this.snackbar = true;
      }
    },

    aracSil(a) {
      this.itemsarac.splice(this.itemsarac.indexOf(a), 1);
    },
    aracEkle() {
      if (this.AracTipleri != null) {
        var newCar = {
          AnaTip: this.Aractipi.AnaTip,
          AltTip: this.Aractipi.AltTip,
          AracAdi: this.Aractipi.AracAdi,
          YazEnAz: this.Aractipi.YazEnAz,
          YazEnCok: this.Aractipi.YazEnCok,
          KisEnAz: this.Aractipi.KisEnAz,
          KisEnCok: this.Aractipi.KisEnCok,
        };
        // newCar=this.Aractipi
        this.itemsarac.push(newCar);
      } else {
        this.text1 = this.$t('Please-select-Vehicle-Type')
        this.snackbar = true;
      }
    },
    menuSil(a) {
      this.itemsmenu.splice(this.itemsmenu.indexOf(a), 1);
    },
    menuEkle() {
      if (this.RestaurantMenu.Kod != null && this.RestaurantMenu.Menu) {
        var menu = {
          Kod: this.RestaurantMenu.Kod,
          Menu: this.RestaurantMenu.Menu,
        };
        // newCar=this.Aractipi
        this.itemsmenu.push(menu);
      } else {
        this.text1 = this.$t('Code-Menu-Name-cannot-left-blank');
        this.snackbar = true;
      }
    },
    turSil(a) {
      this.itemstur.splice(this.itemstur.indexOf(a), 1);
    },
    aktiviteSil(a) {
      this.itemsaktivite.splice(this.itemsaktivite.indexOf(a), 1);
    },
    turEkle() {
      if (
        this.Turlar.Kod != null &&
        this.Turlar.Aciklama != null &&
        this.Turlar.DonemBas != null &&
        this.Turlar.DonemBit != null &&
        this.Turlar.Yaz != null &&
        this.Turlar.Kis != null &&
        this.Turlar.Tip != null &&
        this.Turlar.Yer != null
      ) {
        var tur = {
          Kod: this.Turlar.Kod,
          Aciklama: this.Turlar.Aciklama,
          DonemBas: this.Turlar.DonemBas,
          DonemBit: this.Turlar.DonemBit,
          Yaz: this.Turlar.Yaz,
          Kis: this.Turlar.Kis,
          Tip: this.Turlar.Tip,
          Yer: this.Turlar.Yer,
        };
        this.itemstur.push(tur);
      } else {
        this.text1 = "Lütfen tüm bilgileri eksiksiz doldurunuz.";
        this.snackbar = true;
      }
    },
    aktiviteEkle() {
      if (
        this.Aktivite.Kod != null &&
        this.Aktivite.Aciklama != null &&
        this.Aktivite.DonemBas != null &&
        this.Aktivite.DonemBit != null &&
        this.Aktivite.Yaz != null &&
        this.Aktivite.Kis != null
      ) {
        var aktivite = {
          Kod: this.Aktivite.Kod,
          Aciklama: this.Aktivite.Aciklama,
          DonemBas: this.Aktivite.DonemBas,
          DonemBit: this.Aktivite.DonemBit,
          Yaz: this.Aktivite.Yaz,
          Kis: this.Aktivite.Kis,
        };
        this.itemsaktivite.push(aktivite);
      } else {
        this.text1 = "Lütfen tüm bilgileri eksiksiz doldurunuz.";
        this.snackbar = true;
      }
    },
    tratasSil(a) {
      this.itemstransfertas.splice(this.itemstransfertas.indexOf(a), 1);
    },
    tratasEkle() {
      if (this.TraTas.Kod != null && this.TraTas.Aciklama) {
        var tratas = {
          Kod: this.TraTas.Kod,
          Aciklama: this.TraTas.Aciklama,
        };
        this.itemstransfertas.push(tratas);
      } else {
        this.text1 = "Lütfen tüm bilgileri eksiksiz doldurunuz.";
        this.snackbar = true;
      }
    },
    aracmarkaGetir() {
      tool.http_post(this, "AracMarkaList", {}).then(
        (response) => {
          if (response.body.Status == true) {
            this.itemsaracmarka = response.body.data;
          } else {
            this.text1 = "Service Unavailable-AracMarkaList";
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Service Unavailable-AracMarkaList";
          this.snackbar = true;
        }
      );
    },
    aracmodelGetir(a) {
      var params = {
        MarkaId: a,
      };
      tool.http_post(this, "AracModelList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.itemsaracmodel = response.body.data;
          } else {
            this.text1 = "Service Unavailable-AracModelList ";
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Service Unavailable-AracModelList ";
          this.snackbar = true;
        }
      );
    },

    aracozelliklerGetir() {
      tool.http_post(this, "AracAlanList", {}).then(
        (response) => {
          if (response.body.Status == true) {
            this.aracOzelliklertumList = response.body.data;
          } else {
            this.text1 = "Service Unavailable-AracAlanList";
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Service Unavailable-AracAlanList";
          this.snackbar = true;
        }
      );
    },
    ozelliklerGetir() {
      tool.http_post(this, "OtelOzellikList", {}).then(
        (response) => {
          if (response.body.Status == true) {
            this.ucretsizOzelliklertumList = response.body.data;
            this.ucretliOzelliklertumList = response.body.data;
          } else {
            this.text1 = "Service Unavailable";
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        }
      );
    },
    kategoriGetir() {
      tool.http_post(this, "OtelKategoriList", {}).then(
        (response) => {
          if (response.body.Status == true) {
            this.kategoriitems = response.body.data;
          } else {
            this.text1 = "Service Unavailable";
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        }
      );
    },
    karsidegeral(val) {
      if (val == true) {
        return false;
      } else if (val == false) {
        return false;
      }
    },
    DefaultIcAyarlar(a, b) {
      var nerden = b;
      if (this.ServisParametre.DefaultServis11 == true && nerden != "11") {
        this.ServisParametre.DefaultServis11 = this.karsidegeral(a);
      }
      if (this.ServisParametre.DefaultServis12 === true && nerden != "12") {
        this.ServisParametre.DefaultServis12 = this.karsidegeral(a);
      }
      if (this.ServisParametre.DefaultServis13 === true && nerden != "13") {
        this.ServisParametre.DefaultServis13 = this.karsidegeral(a);
      }
      if (this.ServisParametre.DefaultServis15 === true && nerden != "15") {
        this.ServisParametre.DefaultServis15 = this.karsidegeral(a);
      }
      if (this.ServisParametre.DefaultServis19 === true && nerden != "19") {
        this.ServisParametre.DefaultServis19 = this.karsidegeral(a);
      }
    },
    DefaultDisAyarlar(a, b) {
      var nerden = b;
      if (this.ServisParametre.DefaultServis21 == true && nerden != "21") {
        this.ServisParametre.DefaultServis21 = this.karsidegeral(a);
      }
      if (this.ServisParametre.DefaultServis22 === true && nerden != "22") {
        this.ServisParametre.DefaultServis22 = this.karsidegeral(a);
      }
      if (this.ServisParametre.DefaultServis31 === true && nerden != "31") {
        this.ServisParametre.DefaultServis31 = this.karsidegeral(a);
      }
      if (this.ServisParametre.DefaultServis32 === true && nerden != "32") {
        this.ServisParametre.DefaultServis32 = this.karsidegeral(a);
      }
      if (this.ServisParametre.DefaultServis33 === true && nerden != "33") {
        this.ServisParametre.DefaultServis33 = this.karsidegeral(a);
      }
      if (this.ServisParametre.DefaultServis40 === true && nerden != "40") {
        this.ServisParametre.DefaultServis40 = this.karsidegeral(a);
      }
      if (this.ServisParametre.DefaultServis44 === true && nerden != "44") {
        this.ServisParametre.DefaultServis44 = this.karsidegeral(a);
      }
    },
    islemiptal() {
      this.guncellbtn = false;
      this.havayolukodu = null;
      this.aktarimKodu = null;
      this.havayoluLabel = "Aktarım Kodu";
    },
    satirsil() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var prm = {
        ID: this.silinecekkayit.ID,
      };

      this.$http
        .post(auth.API_URL + "api/Current/CurrentAirlineStreamDelete", prm, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.text1 = response.body.ResponseMessage;
            this.snackbar = true;

            if (response.body.Status == true) {
              this.dialogsor = false;
            }

            var prm = {
              SirketKodu: credentials.SirketKodu,
              CariKodu: this.Current.Code,
            };

            this.$http
              .post(
                auth.API_URL + "api/Current/CurrentAirlineStreamList",
                prm,
                {
                  headers: {
                    Authorization: "Bearer " + auth.getAuthHeader(),
                  },
                }
              )
              .then(
                (response) => {
                  this.aktarimitems = response.body;
                },
                (response) => {
                  if (response.status === 0) {
                    this.text1 = "Service Unavailable";
                    this.snackbar = true;
                  } else {
                    this.text1 = "Service Unavailable";
                    this.snackbar = true;
                  }
                }
              );
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            }
          }
        );
    },
    aktarimGuncelle() {
      if (this.$refs.formtarih.validate()) {
        var credentials = JSON.parse(
          window.localStorage.getItem("credentials")
        );

        var prm = {
          SirketKodu: credentials.SirketKodu,
          CariKodu: this.Current.Code,
          HavayoluKodu: this.havayolukodu,
          AktarimKodu: this.aktarimKodu,
          ID: this.silinecekkayit.ID,
        };

        this.$http
          .post(auth.API_URL + "api/Current/CurrentAirlineStreamSave", prm, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          })
          .then(
            (response) => {
              // this.aktarimitems = response.body

              if (response.body.Status == true) {
                this.islemiptal();
              }

              this.text1 = response.body.ResponseMessage;
              this.snackbar = true;

              var prm = {
                SirketKodu: credentials.SirketKodu,
                CariKodu: this.Current.Code,
              };

              this.$http
                .post(
                  auth.API_URL + "api/Current/CurrentAirlineStreamList",
                  prm,
                  {
                    headers: {
                      Authorization: "Bearer " + auth.getAuthHeader(),
                    },
                  }
                )
                .then(
                  (response) => {
                    this.aktarimitems = response.body;
                  },
                  (response) => {
                    if (response.status === 0) {
                      this.text1 = "Service Unavailable";
                      this.snackbar = true;
                    } else {
                      this.text1 = "Service Unavailable";
                      this.snackbar = true;
                    }
                  }
                );
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable";
                this.snackbar = true;
              } else {
                this.text1 = "Service Unavailable";
                this.snackbar = true;
              }
            }
          );
      }
    },
    satirduzenle(item) {
      (this.guncellbtn = true), (this.havayolukodu = item.HavayoluKodu);
      this.aktarimKodu = item.AktarimKodu;
      this.silinecekkayit = item;
    },
    satirsilsor(item) {
      this.dialogsor = true;
      (this.satirsilbtn = true), (this.silinecekkayit = item);
    },
    aktarimkoduEkle() {
      if (this.$refs.formtarih.validate()) {
        var durum = true;

        if (this.aktarimitems.length == 0) {
          durum = true;
        } else {
          this.aktarimitems.forEach((element) => {
            if (element.HavayoluKodu == this.havayolukodu) {
              durum = false;
            }
          });
        }

        if (durum != false) {
          var credentials = JSON.parse(
            window.localStorage.getItem("credentials")
          );
          var prm = {
            SirketKodu: credentials.SirketKodu,
            CariKodu: this.Current.Code,
            HavayoluKodu: this.havayolukodu,
            AktarimKodu: this.aktarimKodu,
          };

          this.$http
            .post(auth.API_URL + "api/Current/CurrentAirlineStreamSave", prm, {
              headers: {
                Authorization: "Bearer " + auth.getAuthHeader(),
              },
            })
            .then(
              (response) => {
                // this.aktarimitems = response.body

                this.text1 = response.body.ResponseMessage;
                this.snackbar = true;

                var prm = {
                  SirketKodu: credentials.SirketKodu,
                  CariKodu: this.Current.Code,
                };

                this.$http
                  .post(
                    auth.API_URL + "api/Current/CurrentAirlineStreamList",
                    prm,
                    {
                      headers: {
                        Authorization: "Bearer " + auth.getAuthHeader(),
                      },
                    }
                  )
                  .then(
                    (response) => {
                      this.aktarimitems = response.body;
                    },
                    (response) => {
                      if (response.status === 0) {
                        this.text1 = "Service Unavailable";
                        this.snackbar = true;
                      } else {
                        this.text1 = "Service Unavailable";
                        this.snackbar = true;
                      }
                    }
                  );
              },
              (response) => {
                if (response.status === 0) {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                } else {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                }
              }
            );
        } else {
          this.text1 = this.$t('Airline-wish-add-included-records')
          this.snackbar = true;
        }
      }
    },

    guncelle: guncelle,
    Kaydet: Kaydet,
    carisil: carisil,
    karsidegeral: karsidegeral,
    otelgetir: otelgetir,
    acentegetir: acentegetir,
    turoperatorugetir: turoperatorugetir,
    serviskaydet: serviskaydet,
    servissil: servissil,
  },
  beforeMount: beforeMount,
  components: {
    parainput: parainput,
    yuzdeinput,
    tarihim,
    rezervasyonekleridialog,
    vizetipekledialog,
    dosyaekleridialog,
    cariaracomp,
  },
};

function karsidegeral(val) {
  if (val == true) {
    return false;
  } else if (val == false) {
    return false;
  }
}

function serviskaydet() {
  var credentials = JSON.parse(window.localStorage.getItem("credentials"));
  var yenidizi = [];

  var yenikayit = {
    SirketKodu: credentials.SirketKodu,
    CariKodu: this.Current.Code,
    ServisKod: "11",
    Aciklama: "İç Low Cost",
    Fiyat: this.ServisParametre.Fiyat11,
    DovizTip: this.ServisParametre.Doviztip11,
    Yuzdeden: this.icYuzdedenHesapla.Yuzdeden,
    HesapTipi: this.icYuzdedenHesapla.HesapTipi,
    HesapYuzde: this.icYuzdedenHesapla.HesapYuzde,
    DefaultServis: this.ServisParametre.DefaultServis11,
  };
  yenidizi.push(yenikayit);

  yenikayit = {
    SirketKodu: credentials.SirketKodu,
    CariKodu: this.Current.Code,
    ServisKod: "12",
    Aciklama: "İç Eco Cost",
    Fiyat: this.ServisParametre.Fiyat12,
    DovizTip: this.ServisParametre.Doviztip12,
    Yuzdeden: this.icYuzdedenHesapla.Yuzdeden,
    HesapTipi: this.icYuzdedenHesapla.HesapTipi,
    HesapYuzde: this.icYuzdedenHesapla.HesapYuzde,
    DefaultServis: this.ServisParametre.DefaultServis12,
  };
  yenidizi.push(yenikayit);

  yenikayit = {
    SirketKodu: credentials.SirketKodu,
    CariKodu: this.Current.Code,
    ServisKod: "13",
    Aciklama: "İç Business",
    Fiyat: this.ServisParametre.Fiyat13,
    DovizTip: this.ServisParametre.Doviztip13,
    Yuzdeden: this.icYuzdedenHesapla.Yuzdeden,
    HesapTipi: this.icYuzdedenHesapla.HesapTipi,
    HesapYuzde: this.icYuzdedenHesapla.HesapYuzde,
    DefaultServis: this.ServisParametre.DefaultServis13,
  };
  yenidizi.push(yenikayit);

  yenikayit = {
    SirketKodu: credentials.SirketKodu,
    CariKodu: this.Current.Code,
    ServisKod: "15",
    Aciklama: "İç İade",
    Fiyat: this.ServisParametre.Fiyat15,
    DovizTip: this.ServisParametre.Doviztip15,
    Yuzdeden: this.icYuzdedenHesapla.Yuzdeden,
    HesapTipi: this.icYuzdedenHesapla.HesapTipi,
    HesapYuzde: this.icYuzdedenHesapla.HesapYuzde,
    DefaultServis: this.ServisParametre.DefaultServis15,
  };
  yenidizi.push(yenikayit);

  yenikayit = {
    SirketKodu: credentials.SirketKodu,
    CariKodu: this.Current.Code,
    ServisKod: "19",
    Aciklama: "İç Rezervasyon Değişimi",
    Fiyat: this.ServisParametre.Fiyat19,
    DovizTip: this.ServisParametre.Doviztip19,
    Yuzdeden: this.icYuzdedenHesapla.Yuzdeden,
    HesapTipi: this.icYuzdedenHesapla.HesapTipi,
    HesapYuzde: this.icYuzdedenHesapla.HesapYuzde,
    DefaultServis: this.ServisParametre.DefaultServis19,
  };
  yenidizi.push(yenikayit);

  yenikayit = {
    SirketKodu: credentials.SirketKodu,
    CariKodu: this.Current.Code,
    ServisKod: "21",
    Aciklama: "Dış Short Cost",
    Fiyat: this.ServisParametre.Fiyat21,
    DovizTip: this.ServisParametre.Doviztip21,
    Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
    HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
    HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
    DefaultServis: this.ServisParametre.DefaultServis21,
  };
  yenidizi.push(yenikayit);

  yenikayit = {
    SirketKodu: credentials.SirketKodu,
    CariKodu: this.Current.Code,
    ServisKod: "22",
    Aciklama: "Dış Short Business",
    Fiyat: this.ServisParametre.Fiyat22,
    DovizTip: this.ServisParametre.Doviztip22,
    Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
    HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
    HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
    DefaultServis: this.ServisParametre.DefaultServis22,
  };
  yenidizi.push(yenikayit);

  yenikayit = {
    SirketKodu: credentials.SirketKodu,
    CariKodu: this.Current.Code,
    ServisKod: "31",
    Aciklama: "Dış Long Eco",
    Fiyat: this.ServisParametre.Fiyat31,
    DovizTip: this.ServisParametre.Doviztip31,
    Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
    HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
    HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
    DefaultServis: this.ServisParametre.DefaultServis31,
  };
  yenidizi.push(yenikayit);

  yenikayit = {
    SirketKodu: credentials.SirketKodu,
    CariKodu: this.Current.Code,
    ServisKod: "32",
    Aciklama: "Dış Long Business",
    Fiyat: this.ServisParametre.Fiyat32,
    DovizTip: this.ServisParametre.Doviztip32,
    Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
    HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
    HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
    DefaultServis: this.ServisParametre.DefaultServis32,
  };
  yenidizi.push(yenikayit);
  yenikayit = {
    SirketKodu: credentials.SirketKodu,
    CariKodu: this.Current.Code,
    ServisKod: "33",
    Aciklama: "First Class",
    Fiyat: this.ServisParametre.Fiyat33,
    DovizTip: this.ServisParametre.Doviztip33,
    Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
    HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
    HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
    DefaultServis: this.ServisParametre.DefaultServis33,
  };
  yenidizi.push(yenikayit);

  yenikayit = {
    SirketKodu: credentials.SirketKodu,
    CariKodu: this.Current.Code,
    ServisKod: "40",
    Aciklama: "Dış İade",
    Fiyat: this.ServisParametre.Fiyat40,
    DovizTip: this.ServisParametre.Doviztip40,
    Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
    HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
    HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
    DefaultServis: this.ServisParametre.DefaultServis40,
  };
  yenidizi.push(yenikayit);

  yenikayit = {
    SirketKodu: credentials.SirketKodu,
    CariKodu: this.Current.Code,
    ServisKod: "44",
    Aciklama: "Dış Rezervasyon Değişimi",
    Fiyat: this.ServisParametre.Fiyat44,
    DovizTip: this.ServisParametre.Doviztip44,
    Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
    HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
    HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
    DefaultServis: this.ServisParametre.DefaultServis44,
  };
  yenidizi.push(yenikayit);

  var params = yenidizi;

  this.$http
    .post(auth.API_URL + "api/Current/CurrentServiceSave", params, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        this.text1 = response.body.ResponseMessage;
        this.snackbar = true;
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        }
      }
    );
}

function servissil() {
  var credentials = JSON.parse(window.localStorage.getItem("credentials"));

  var params = {
    CompanyCode: credentials.SirketKodu,
    AccountCode: this.Current.Code,
  };

  this.$http
    .post(auth.API_URL + "api/Current/CurrentServiceDelete", params, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        this.text1 = response.body.ResponseMessage;
        this.snackbar = true;
        this.ServisParametre = this.ServisParametreYedek;
        this.icYuzdedenHesapla.Yuzdeden = false;
        this.icYuzdedenHesapla.HesapTipi = null;
        this.icYuzdedenHesapla.HesapYuzde = 0;
        this.DisYuzdedenHesapla.Yuzdeden = false;
        this.DisYuzdedenHesapla.HesapTipi = null;
        this.DisYuzdedenHesapla.HesapYuzde = 0;
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        }
      }
    );
}

function carisil() {
  // burda soralım istiyormusunuz diye

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));

  let params = {
    saticiTipi: this.Satici.SaticiTipi,
    saticiKodu: this.Satici.Kod,
  };
  tool.http_post(this, "SaticiSil", params).then(
    (response) => {
      if (response.body.Status == true) {
        this.text1 = "Kayıt Silindi";
        this.snackbar = true;
        setTimeout(
          function () {
            document.getElementById("backLink").click();
          }.bind(this),
          1200
        );
      } else {
        this.text1 = response.body.ErrorList[0];
        this.snackbar = true;
      }
    },
    (response) => {
      this.text1 = "Hata Oluştu, tekrar deneyiniz";
      this.snackbar = true;
    }
  );
}

function acentegetir(v) {
  if (v.length >= 0) {
    this.loadingacente = true;

    var params = {
      SaticiTipi: 4, //Acente
      Id: null, //eğer varsa ID, nokta atışı yapmak için. varsa 3. ve 4. parametreler işlevsiz kalır
      Kod: null, //eğer varsa Kod, Nokta atışı yapmak için. varsa 4. parametre işlevsiz kalır
      Aciklama: v, //Kullanıcının arama yapması için (maksimum 10 kayıt getirir)
    };

    tool.http_post(this, "SimpleSaticiAra", params).then(
      (response) => {
        if (response.body.Status == true) {
          this.stateacente = response.body.data;
          this.loadingacente = false;
        } else {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
          this.loadingacente = false;
        }
      },
      (response) => {
        this.text1 = "Service Unavailable";
        this.snackbar = true;
        this.loadingacente = false;
      }
    );
  }
}

function turoperatorugetir(v) {
  if (v.length >= 0) {
    //  this.loadingacente = true

    var params = {
      SaticiTipi: 12, //Acente
      Id: null, //eğer varsa ID, nokta atışı yapmak için. varsa 3. ve 4. parametreler işlevsiz kalır
      Kod: null, //eğer varsa Kod, Nokta atışı yapmak için. varsa 4. parametre işlevsiz kalır
      Aciklama: v, //Kullanıcının arama yapması için (maksimum 10 kayıt getirir)
    };

    tool.http_post(this, "SimpleSaticiAra", params).then(
      (response) => {
        if (response.body.Status == true) {
          this.stateturoperatoru = response.body.data;
          // this.loadingacente = false
        } else {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
          // this.loadingacente = false
        }
      },
      (response) => {
        this.text1 = "Service Unavailable";
        this.snackbar = true;
        //  this.loadingacente = false
      }
    );
  }
}

function otelgetir(v) {
  if (v.length >= 0) {
    //  this.loadingacente = true

    var params = {
      SaticiTipi: 1, //Acente
      Id: null, //eğer varsa ID, nokta atışı yapmak için. varsa 3. ve 4. parametreler işlevsiz kalır
      Kod: null, //eğer varsa Kod, Nokta atışı yapmak için. varsa 4. parametre işlevsiz kalır
      Aciklama: v, //Kullanıcının arama yapması için (maksimum 10 kayıt getirir)
    };

    tool.http_post(this, "SimpleSaticiAra", params).then(
      (response) => {
        if (response.body.Status == true) {
          this.stateotel = response.body.data;
          // this.loadingacente = false
        } else {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
          // this.loadingacente = false
        }
      },
      (response) => {
        this.text1 = "Service Unavailable";
        this.snackbar = true;
        //  this.loadingacente = false
      }
    );
  }
}

function beforeMount() {
  var credentials = JSON.parse(window.localStorage.getItem("credentials"));

  var params = {
    CompanyCode: credentials.SirketKodu,
  };

  tool.http_post(this, "UlkeList", {}).then(
    (response) => {
      if (response.body.Status == true) {
        this.ulkeTipi = response.body.data;
      } else {
        this.text1 = "Service Unavailable";
        this.snackbar = true;
      }
    },
    (response) => {
      this.text1 = "Service Unavailable";
      this.snackbar = true;
    }
  );

  if (this.$route.query.isl == "get" && this.$route.query.tip == 1) {
    this.baslik = "Otel Güncelle";
    this.kaydetbuton = false;
    this.silbuton = true;
    this.guncellebuton = true;
    this.ozelliklerGetir();
    this.kategoriGetir();
  } else if (this.$route.query.isl == "yeni" && this.$route.query.tip == "1") {
    this.baslik = "Otel Ekle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = true;
    this.silbuton = false;
    this.guncellebuton = false;
    this.ozelliklerGetir();
    this.kategoriGetir();
  } else if (this.$route.query.isl == "yeni" && this.$route.query.tip == "2") {
    this.baslik = "Transfer Ekle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = true;
    this.silbuton = false;
    this.guncellebuton = false;
    this.aracozelliklerGetir();
  } else if (this.$route.query.isl == "get" && this.$route.query.tip == "2") {
    this.baslik = "Transfer Düzenle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = false;
    this.silbuton = true;
    this.guncellebuton = true;
    this.aracozelliklerGetir();
  } else if (this.$route.query.isl == "yeni" && this.$route.query.tip == "5") {
    this.baslik = "Rent A Car Ekle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = true;
    this.silbuton = false;
    this.guncellebuton = false;
    this.aracmarkaGetir();
  } else if (this.$route.query.isl == "get" && this.$route.query.tip == "5") {
    this.baslik = "Rent A Car Düzenle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = false;
    this.silbuton = true;
    this.guncellebuton = true;
    this.aracmarkaGetir();
  } else if (this.$route.query.isl == "yeni" && this.$route.query.tip == "3") {
    this.baslik = "Restaurant Ekle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = true;
    this.silbuton = false;
    this.guncellebuton = false;
  } else if (this.$route.query.isl == "get" && this.$route.query.tip == "3") {
    this.baslik = "Restaurant Düzenle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = false;
    this.silbuton = true;
    this.guncellebuton = true;
  } else if (this.$route.query.isl == "yeni" && this.$route.query.tip == "4") {
    this.baslik = "Acente Ekle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = true;
    this.silbuton = false;
    this.guncellebuton = false;
  } else if (this.$route.query.isl == "get" && this.$route.query.tip == "4") {
    this.baslik = "Acente Düzenle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = false;
    this.silbuton = true;
    this.guncellebuton = true;
  } else if (this.$route.query.isl == "yeni" && this.$route.query.tip == "6") {
    this.baslik = "Rehber Ekle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = true;
    this.silbuton = false;
    this.guncellebuton = false;
  } else if (this.$route.query.isl == "get" && this.$route.query.tip == "6") {
    this.baslik = "Rehber Düzenle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = false;
    this.silbuton = true;
    this.guncellebuton = true;
  } else if (this.$route.query.isl == "yeni" && this.$route.query.tip == "7") {
    this.baslik = "Müze Ekle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = true;
    this.silbuton = false;
    this.guncellebuton = false;
  } else if (this.$route.query.isl == "get" && this.$route.query.tip == "7") {
    this.baslik = "Müze Düzenle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = false;
    this.silbuton = true;
    this.guncellebuton = true;
  } else if (this.$route.query.isl == "yeni" && this.$route.query.tip == "8") {
    this.baslik = "Charter Havayolu Ekle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = true;
    this.silbuton = false;
    this.guncellebuton = false;
    this.formnoGetir();
  } else if (this.$route.query.isl == "get" && this.$route.query.tip == "8") {
    this.baslik = "Charter Havayolu Düzenle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = false;
    this.silbuton = true;
    this.guncellebuton = true;
    this.formnoGetir();
  } else if (this.$route.query.isl == "yeni" && this.$route.query.tip == "9") {
    this.baslik = "Gemi Ekle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = true;
    this.silbuton = false;
    this.guncellebuton = false;
    this.ozelliklerGetir();
    this.kategoriGetir();
  } else if (this.$route.query.isl == "get" && this.$route.query.tip == "9") {
    this.baslik = "Gemi Düzenle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = false;
    this.silbuton = true;
    this.guncellebuton = true;
    this.ozelliklerGetir();
    this.kategoriGetir();
  } else if (this.$route.query.isl == "yeni" && this.$route.query.tip == "10") {
    this.baslik = "Diğer Satıcı Ekle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = true;
    this.silbuton = false;
    this.guncellebuton = false;
  } else if (this.$route.query.isl == "get" && this.$route.query.tip == "10") {
    this.baslik = "Diğer Satıcı Düzenle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = false;
    this.silbuton = true;
    this.guncellebuton = true;
  } else if (this.$route.query.isl == "yeni" && this.$route.query.tip == "11") {
    this.baslik = "Vize Ekle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = true;
    this.silbuton = false;
    this.guncellebuton = false;
  } else if (this.$route.query.isl == "get" && this.$route.query.tip == "11") {
    this.baslik = "Vize Düzenle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = false;
    this.silbuton = true;
    this.guncellebuton = true;
  } else if (this.$route.query.isl == "yeni" && this.$route.query.tip == "12") {
    this.baslik = "Tur Operatörü Ekle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = true;
    this.silbuton = false;
    this.guncellebuton = false;
  } else if (this.$route.query.isl == "get" && this.$route.query.tip == "12") {
    this.baslik = "Tur Operatörü  Düzenle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = false;
    this.silbuton = true;
    this.guncellebuton = true;
    this.dovizgetir();
  } else if (this.$route.query.isl == "yeni" && this.$route.query.tip == "14") {
    this.baslik = "Sigorta Ekle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = true;
    this.silbuton = false;
    this.guncellebuton = false;
    this.dovizgetir();
  } else if (this.$route.query.isl == "get" && this.$route.query.tip == "14") {
    this.baslik = "Sigorta   Düzenle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = false;
    this.silbuton = true;
    this.guncellebuton = true;
  } else if (this.$route.query.isl == "yeni" && this.$route.query.tip == "15") {
    this.baslik = "Feribot Ekle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = true;
    this.silbuton = false;
    this.guncellebuton = false;
  } else if (this.$route.query.isl == "get" && this.$route.query.tip == "15") {
    this.baslik = "Feribot  Düzenle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = false;
    this.silbuton = true;
    this.guncellebuton = true;
  } else if (this.$route.query.isl == "yeni" && this.$route.query.tip == "16") {
    this.baslik = "Golf Ekle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = true;
    this.silbuton = false;
    this.guncellebuton = false;
  } else if (this.$route.query.isl == "get" && this.$route.query.tip == "16") {
    this.baslik = "Golf Düzenle";
    this.Satici.SaticiTipi = this.$route.query.tip;
    this.kaydetbuton = false;
    this.silbuton = true;
    this.guncellebuton = true;
  }

  if (
    this.$route.query.isl == "get" &&
    this.$route.query.kod != null &&
    this.$route.query.kod != "" &&
    this.$route.query.tip != null &&
    this.$route.query.tip != ""
  ) {
    var prm = {
      saticiKodu: unescape(this.$route.query.kod),
      saticiTipi: this.$route.query.tip,
    };

    tool.http_post(this, "SaticiKodBul", prm).then(
      (response) => {
        if (response.body.Status == true) {
          if (response.body.Satici != null) {
            this.Satici = response.body.Satici;
            this.Satici.Cari_Kod.kod = response.body.Satici.Cari_Kod.kod;
            this.Satici.Ulke = response.body.Satici.Ulke;
            this.Satici.Sehir = response.body.Satici.Sehir;
            this.getCity(response.body.Satici.Ulke);

            //this.getDistinct(response.body.Satici.Sehir);
            if (response.body.Satici.SaticiTipi == 1) {
              this.itemsodakonum = response.body.Satici.stOtel.OdaKonum;

              var list = [];
              this.Satici.stOtel.Kategori = parseInt(
                response.body.Satici.stOtel.Kategori
              );

              if (response.body.Satici.stOtel.Ucretsizler != null) {
                response.body.Satici.stOtel.Ucretsizler.forEach((element) => {
                  list.push(parseInt(element));
                });

                this.Satici.stOtel.Ucretsizler = list;
              }

              if (response.body.Satici.stOtel.Ucretliler != null) {
                list = [];

                response.body.Satici.stOtel.Ucretliler.forEach((element) => {
                  list.push(parseInt(element));
                });
                this.Satici.stOtel.Ucretliler = list;
              }
            } else if (response.body.Satici.SaticiTipi == 2) {
              this.itemsarac = response.body.Satici.stArac.AracTipi;
            } else if (response.body.Satici.SaticiTipi == 3) {
              this.itemsmenu = response.body.Satici.stRestaurant.Menu;
            } else if (response.body.Satici.SaticiTipi == 4) {
              this.itemstransfertas =
                response.body.Satici.stAcente.TransferTasima;
              this.itemstur = response.body.Satici.stAcente.Turlar;
              var seciliitemsacente = {
                Aciklama: response.body.Satici.stAcente.AnaAcenteKod.isim,
                Kod: response.body.Satici.stAcente.AnaAcenteKod.kod,
                Id: response.body.Satici.stAcente.AnaAcenteKod.id,
              };

              this.stateacente.push(seciliitemsacente);
              this.secilenacente =
                response.body.Satici.stAcente.AnaAcenteKod.kod;
            } else if (response.body.Satici.SaticiTipi == 5) {
              this.itemsaracsinifi = response.body.Satici.stRentACar.AracTipi;
              this.itemsrentacarliste = response.body.Satici.stRentACar.Araclar;
            } else if (response.body.Satici.SaticiTipi == 6) {
              response.body.Satici.stRehber.Diller.forEach((element) => {
                this.rehberbildigiDiller.push(element);
              });
            } else if (response.body.Satici.SaticiTipi == 7) {
              this.Satici.stMuze.AcikSaat1 = this.timekontrol(
                response.body.Satici.stMuze.AcikSaat1
              );
              this.Satici.stMuze.AcikSaat2 = this.timekontrol(
                response.body.Satici.stMuze.AcikSaat2
              );
            } else if (response.body.Satici.SaticiTipi == 9) {
              var list = [];
              this.Satici.stGemi.Kategori = parseInt(
                response.body.Satici.stGemi.Kategori
              );

              this.itemsgemiodakonum = response.body.Satici.stGemi.OdaKonum;

              if (response.body.Satici.stGemi.Ucretsizler != null) {
                response.body.Satici.stGemi.Ucretsizler.forEach((element) => {
                  list.push(parseInt(element));
                });

                this.Satici.stGemi.Ucretsizler = list;
              }

              if (response.body.Satici.stGemi.Ucretliler != null) {
                list = [];

                response.body.Satici.stGemi.Ucretliler.forEach((element) => {
                  list.push(parseInt(element));
                });
                this.Satici.stGemi.Ucretliler = list;
              }
            } else if (response.body.Satici.SaticiTipi == 10) {
              var list = [];
              this.itemsaktivite = response.body.Satici.stDiger.Aktivite;
            } else if (response.body.Satici.SaticiTipi == 11) {
              this.Satici.stKonsolosluk.Saat1 = this.timekontrol(
                response.body.Satici.stKonsolosluk.Saat1
              );
              this.Satici.stKonsolosluk.Saat2 = this.timekontrol(
                response.body.Satici.stKonsolosluk.Saat2
              );
            } else if (response.body.Satici.SaticiTipi == 15) {
              var seciliitemturoperator = {
                Aciklama: response.body.Satici.stFeribot.TurOperatoru.isim,
                Kod: response.body.Satici.stFeribot.TurOperatoru.kod,
                Id: response.body.Satici.stFeribot.TurOperatoru.id,
              };

              this.stateturoperatoru.push(seciliitemturoperator);
              this.Satici.stFeribot.TurOperatoru.kod =
                response.body.Satici.stFeribot.TurOperatoru.kod;
            } else if (response.body.Satici.SaticiTipi == 16) {
              var seciliitemturoperator = {
                Aciklama: response.body.Satici.stGolf.OtelKod.isim,
                Kod: response.body.Satici.stGolf.OtelKod.kod,
                Id: response.body.Satici.stGolf.OtelKod.id,
              };

              this.stateotel.push(seciliitemturoperator);
              this.Satici.stGolf.OtelKod = response.body.Satici.stGolf.OtelKod;
            }
            this.Satici.Yer = response.body.Satici.Yer;
            this.Satici.SaticiKonumu = response.body.Satici.SaticiKonumu;
            this.Satici.Cari_Kod.kod = response.body.Satici.Cari_Kod.kod;
          } else {
            this.text1 = "Kayıt bulunamadı";
            this.snackbar = true;
          }
        } else {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        }
      },
      (response) => {
        this.text1 = "Service Unavailable";
        this.snackbar = true;
      }
    );
  }
}

function Kaydet() {
  var credentials = JSON.parse(window.localStorage.getItem("credentials"));
  this.counter += 1;
  if(this.counter == 1){
  if (this.$refs.formsatici.validate()) {
    if (this.Satici.SaticiTipi == 1) {
      this.Satici.stOtel.OdaKonum = this.itemsodakonum;
    }

    if (this.Satici.SaticiTipi == 2) {
      this.Satici.stArac.AracTipi = this.itemsarac;
    }

    if (this.Satici.SaticiTipi == 3) {
      this.Satici.stRestaurant.Menu = this.itemsmenu;
    }

    if (this.Satici.SaticiTipi == 4) {
      this.Satici.stAcente.TransferTasima = this.itemstransfertas;
      this.Satici.stAcente.Turlar = this.itemstur;

      this.stateacente.forEach((element) => {
        if ((this.secilenacente = element.Kod)) {
          this.Satici.stAcente.AnaAcenteKod.kod = element.Kod;
          this.Satici.stAcente.AnaAcenteKod.isim = element.Aciklama;
          this.Satici.stAcente.AnaAcenteKod.id = element.Id;
        }
      });
    }

    if (this.Satici.SaticiTipi == 5) {
      this.Satici.stRentACar.AracTipi = this.itemsaracsinifi;
      this.Satici.stRentACar.Araclar = this.itemsrentacarliste;
    }

    if (this.Satici.SaticiTipi == 6) {
      this.Satici.stRehber.Diller = [];
      this.rehberbildigiDiller.forEach((element) => {
        var dil = {
          Check: true,
          Dil: element,
        };
        this.Satici.stRehber.Diller.push(dil);
      });
    }

    if (this.Satici.SaticiTipi == 9) {
      this.Satici.stGemi.OdaKonum = this.itemsgemiodakonum;
    }

    if (this.Satici.SaticiTipi == 10) {
      this.Satici.stDiger.Aktivite = this.itemsaktivite;
    }
    

    var prm = this.Satici;
   

    tool.http_post(this, "SaticiKayit", prm).then(
      (response) => {
        if (response.body.Status == true) {
          this.text1 = "Kayıt edildi";
          this.snackbar = true;
          this.counter = 0;
        } else {
          this.text1 = response.body.ErrorList[0];
          this.snackbar = true;
          this.counter = 0;
        }
      },
      (response) => {
        this.text1 = "Service Unavailable";
        this.snackbar = true;
        this.counter = 0;
      }
    );
  } else {
    this.counter = 0;
    this.active = 0;
  }
  }
}

function guncelle() {
  var credentials = JSON.parse(window.localStorage.getItem("credentials"));

  if (this.$refs.formsatici.validate()) {
    if (this.Satici.SaticiTipi == 1) {
      this.Satici.stOtel.OdaKonum = this.itemsodakonum;
    }

    if (this.Satici.SaticiTipi == 2) {
      this.Satici.stArac.AracTipi = this.itemsarac;
    }

    if (this.Satici.SaticiTipi == 3) {
      this.Satici.stRestaurant.Menu = this.itemsmenu;
    }

    if (this.Satici.SaticiTipi == 4) {
      this.Satici.stAcente.TransferTasima = this.itemstransfertas;
      this.Satici.stAcente.Turlar = this.itemstur;

      this.stateacente.forEach((element) => {
        if ((this.secilenacente = element.Kod)) {
          this.Satici.stAcente.AnaAcenteKod.kod = element.Kod;
          this.Satici.stAcente.AnaAcenteKod.isim = element.Aciklama;
          this.Satici.stAcente.AnaAcenteKod.id = element.Id;
        }
      });
    }

    if (this.Satici.SaticiTipi == 5) {
      this.Satici.stRentACar.AracTipi = this.itemsaracsinifi;
      this.Satici.stRentACar.Araclar = this.itemsrentacarliste;
    }

    if (this.Satici.SaticiTipi == 6) {
      this.Satici.stRehber.Diller = [];
      this.rehberbildigiDiller.forEach((element) => {
        var dil = {
          Check: true,
          Dil: element,
        };
        this.Satici.stRehber.Diller.push(dil);
      });
    }
    if (this.Satici.SaticiTipi == 9) {
      this.Satici.stGemi.OdaKonum = this.itemsgemiodakonum;
    }

    if (this.Satici.SaticiTipi == 10) {
      this.Satici.stDiger.Aktivite = this.itemsaktivite;
    }

    var prm = JSON.parse(JSON.stringify(this.Satici));
    if (prm.Cari_Kod.kod == null) {
      prm.Cari_Kod = null;
    }

    tool.http_post(this, "SaticiUpdate", prm).then(
      (response) => {
        if (response.body.Status == true) {
          this.text1 = "Kayıt güncellendi";
          this.snackbar = true;
        } else {
          this.text1 = response.body.ErrorList[0];
          this.snackbar = true;
        }
      },
      (response) => {
        this.text1 = "Service Unavailable";
        this.snackbar = true;
      }
    );
  } else {
    this.active = 0;
  }
}
</script>

<style scoped>
@import "../../../../assets/css/custom.css";
</style>
